import { g as getDefaultExportFromCjs } from "./_commonjsHelpers-C6fGbg64.js";
var arrays_1, hasRequiredArrays;
function requireArrays() {
  if (hasRequiredArrays) return arrays_1;
  hasRequiredArrays = 1;
  var C = {
    range: function(f, F) {
      var a = F - f, o = new Array(a), e, B;
      for (e = 0, B = f; e < a; e++, B++)
        o[e] = B;
      return o;
    },
    find: function(f, F) {
      var a = f.length, o;
      if (typeof F == "function") {
        for (o = 0; o < a; o++)
          if (F(f[o]))
            return f[o];
      } else
        for (o = 0; o < a; o++)
          if (f[o] === F)
            return f[o];
    },
    indexOf: function(f, F) {
      var a = f.length, o;
      if (typeof F == "function") {
        for (o = 0; o < a; o++)
          if (F(f[o]))
            return o;
      } else
        for (o = 0; o < a; o++)
          if (f[o] === F)
            return o;
      return -1;
    },
    contains: function(f, F) {
      return C.indexOf(f, F) !== -1;
    },
    each: function(f, F) {
      var a = f.length, o;
      for (o = 0; o < a; o++)
        F(f[o], o);
    },
    map: function(f, F) {
      var a = f.length, o = new Array(a), e;
      for (e = 0; e < a; e++)
        o[e] = F(f[e], e);
      return o;
    },
    pluck: function(f, F) {
      return C.map(f, function(a) {
        return a[F];
      });
    },
    every: function(f, F) {
      var a = f.length, o;
      for (o = 0; o < a; o++)
        if (!F(f[o]))
          return !1;
      return !0;
    },
    some: function(f, F) {
      var a = f.length, o;
      for (o = 0; o < a; o++)
        if (F(f[o]))
          return !0;
      return !1;
    }
  };
  return arrays_1 = C, arrays_1;
}
var objects_1, hasRequiredObjects;
function requireObjects() {
  if (hasRequiredObjects) return objects_1;
  hasRequiredObjects = 1;
  var C = {
    keys: function(f) {
      var F = [], a;
      for (a in f)
        f.hasOwnProperty(a) && F.push(a);
      return F;
    },
    values: function(f) {
      var F = [], a;
      for (a in f)
        f.hasOwnProperty(a) && F.push(f[a]);
      return F;
    },
    clone: function(f) {
      var F = {}, a;
      for (a in f)
        f.hasOwnProperty(a) && (F[a] = f[a]);
      return F;
    },
    defaults: function(f, F) {
      var a;
      for (a in F)
        F.hasOwnProperty(a) && (a in f || (f[a] = F[a]));
    }
  };
  return objects_1 = C, objects_1;
}
var classes_1, hasRequiredClasses;
function requireClasses() {
  if (hasRequiredClasses) return classes_1;
  hasRequiredClasses = 1;
  var C = {
    subclass: function(f, F) {
      function a() {
        this.constructor = f;
      }
      a.prototype = F.prototype, f.prototype = new a();
    }
  };
  return classes_1 = C, classes_1;
}
var grammarError, hasRequiredGrammarError;
function requireGrammarError() {
  if (hasRequiredGrammarError) return grammarError;
  hasRequiredGrammarError = 1;
  var C = requireClasses();
  function f(F, a) {
    this.name = "GrammarError", this.message = F, this.location = a, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, f);
  }
  return C.subclass(f, Error), grammarError = f, grammarError;
}
var parser$1, hasRequiredParser;
function requireParser() {
  if (hasRequiredParser) return parser$1;
  hasRequiredParser = 1;
  function C(a, o) {
    function e() {
      this.constructor = a;
    }
    e.prototype = o.prototype, a.prototype = new e();
  }
  function f(a, o, e, B) {
    this.message = a, this.expected = o, this.found = e, this.location = B, this.name = "SyntaxError", typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, f);
  }
  C(f, Error), f.buildMessage = function(a, o) {
    var e = {
      literal: function(m) {
        return '"' + v(m.text) + '"';
      },
      class: function(m) {
        var _ = "", S;
        for (S = 0; S < m.parts.length; S++)
          _ += m.parts[S] instanceof Array ? h(m.parts[S][0]) + "-" + h(m.parts[S][1]) : h(m.parts[S]);
        return "[" + (m.inverted ? "^" : "") + _ + "]";
      },
      any: function(m) {
        return "any character";
      },
      end: function(m) {
        return "end of input";
      },
      other: function(m) {
        return m.description;
      }
    };
    function B(m) {
      return m.charCodeAt(0).toString(16).toUpperCase();
    }
    function v(m) {
      return m.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(_) {
        return "\\x0" + B(_);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(_) {
        return "\\x" + B(_);
      });
    }
    function h(m) {
      return m.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(_) {
        return "\\x0" + B(_);
      }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(_) {
        return "\\x" + B(_);
      });
    }
    function $(m) {
      return e[m.type](m);
    }
    function k(m) {
      var _ = new Array(m.length), S, M;
      for (S = 0; S < m.length; S++)
        _[S] = $(m[S]);
      if (_.sort(), _.length > 0) {
        for (S = 1, M = 1; S < _.length; S++)
          _[S - 1] !== _[S] && (_[M] = _[S], M++);
        _.length = M;
      }
      switch (_.length) {
        case 1:
          return _[0];
        case 2:
          return _[0] + " or " + _[1];
        default:
          return _.slice(0, -1).join(", ") + ", or " + _[_.length - 1];
      }
    }
    function P(m) {
      return m ? '"' + v(m) + '"' : "end of input";
    }
    return "Expected " + k(a) + " but " + P(o) + " found.";
  };
  function F(a, o) {
    o = o !== void 0 ? o : {};
    var e = {}, B = { Grammar: Pe }, v = Pe, h = function(u, i) {
      return {
        type: "grammar",
        initializer: pi(u, 0),
        rules: Ve(i, 0),
        location: w()
      };
    }, $ = function(u) {
      return { type: "initializer", code: u, location: w() };
    }, k = "=", P = g("=", !1), m = function(u, i, t) {
      return {
        type: "rule",
        name: u,
        expression: i !== null ? {
          type: "named",
          name: i[0],
          expression: t,
          location: w()
        } : t,
        location: w()
      };
    }, _ = "/", S = g("/", !1), M = function(u, i) {
      return i.length > 0 ? {
        type: "choice",
        alternatives: ze(u, i, 3),
        location: w()
      } : u;
    }, K = function(u, i) {
      return i !== null ? {
        type: "action",
        expression: u,
        code: i[1],
        location: w()
      } : u;
    }, Q = function(u, i) {
      return i.length > 0 ? {
        type: "sequence",
        elements: ze(u, i, 1),
        location: w()
      } : u;
    }, j = ":", D = g(":", !1), d = function(u, i) {
      return {
        type: "labeled",
        label: u,
        expression: i,
        location: w()
      };
    }, b = function(u, i) {
      return {
        type: ai[u],
        expression: i,
        location: w()
      };
    }, T = "$", I = g("$", !1), L = "&", Z = g("&", !1), Pu = "!", _u = g("!", !1), Je = function(u, i) {
      return {
        type: Ai[i],
        expression: u,
        location: w()
      };
    }, Ye = "?", We = g("?", !1), Xe = "*", Ze = g("*", !1), Ke = "+", Qe = g("+", !1), u0 = "(", e0 = g("(", !1), r0 = ")", s0 = g(")", !1), i0 = function(u) {
      return u.type === "labeled" || u.type === "sequence" ? { type: "group", expression: u } : u;
    }, t0 = function(u) {
      return { type: "rule_ref", name: u, location: w() };
    }, n0 = function(u, i) {
      return {
        type: oi[u],
        code: i,
        location: w()
      };
    }, yu = Ns(), a0 = J("whitespace"), A0 = "	", o0 = g("	", !1), c0 = "\v", p0 = g("\v", !1), l0 = "\f", f0 = g("\f", !1), E0 = " ", C0 = g(" ", !1), F0 = " ", B0 = g(" ", !1), D0 = "\uFEFF", g0 = g("\uFEFF", !1), d0 = /^[\n\r\u2028\u2029]/, h0 = N([`
`, "\r", "\u2028", "\u2029"], !1, !1), $0 = J("end of line"), v0 = `
`, m0 = g(`
`, !1), ku = `\r
`, R0 = g(`\r
`, !1), b0 = "\r", x0 = g("\r", !1), P0 = "\u2028", _0 = g("\u2028", !1), y0 = "\u2029", k0 = g("\u2029", !1), S0 = J("comment"), uu = "/*", Su = g("/*", !1), H = "*/", W = g("*/", !1), Iu = "//", I0 = g("//", !1), O0 = function(u) {
      return u;
    }, T0 = J("identifier"), L0 = function(u, i) {
      return u + i.join("");
    }, q0 = "_", j0 = g("_", !1), V = "\\", z = g("\\", !1), eu = function(u) {
      return u;
    }, w0 = "‌", N0 = g("‌", !1), U0 = "‍", H0 = g("‍", !1), G0 = J("literal"), Ou = "i", Tu = g("i", !1), M0 = function(u, i) {
      return {
        type: "literal",
        value: u,
        ignoreCase: i !== null,
        location: w()
      };
    }, V0 = J("string"), ru = '"', su = g('"', !1), Lu = function(u) {
      return u.join("");
    }, iu = "'", tu = g("'", !1), nu = function() {
      return be();
    }, z0 = J("character class"), J0 = "[", Y0 = g("[", !1), W0 = "^", X0 = g("^", !1), qu = "]", ju = g("]", !1), Z0 = function(u, i, t) {
      return {
        type: "class",
        parts: ci(i),
        inverted: u !== null,
        ignoreCase: t !== null,
        location: w()
      };
    }, K0 = "-", Q0 = g("-", !1), ur = function(u, i) {
      return u.charCodeAt(0) > i.charCodeAt(0) && ws(
        "Invalid character range: " + be() + "."
      ), [u, i];
    }, er = function() {
      return "";
    }, rr = "0", sr = g("0", !1), ir = function() {
      return "\0";
    }, tr = "b", nr = g("b", !1), ar = function() {
      return "\b";
    }, Ar = "f", or = g("f", !1), cr = function() {
      return "\f";
    }, pr = "n", lr = g("n", !1), fr = function() {
      return `
`;
    }, Er = "r", Cr = g("r", !1), Fr = function() {
      return "\r";
    }, Br = "t", Dr = g("t", !1), gr = function() {
      return "	";
    }, dr = "v", hr = g("v", !1), $r = function() {
      return "\v";
    }, wu = "x", Nu = g("x", !1), Uu = "u", Hu = g("u", !1), Gu = function(u) {
      return String.fromCharCode(parseInt(u, 16));
    }, vr = /^[0-9]/, mr = N([["0", "9"]], !1, !1), Rr = /^[0-9a-f]/i, br = N([["0", "9"], ["a", "f"]], !1, !0), xr = ".", Pr = g(".", !1), _r = function() {
      return { type: "any", location: w() };
    }, yr = J("code block"), Cu = "{", Fu = g("{", !1), Bu = "}", Du = g("}", !1), kr = function(u) {
      return u;
    }, au = /^[{}]/, Au = N(["{", "}"], !1, !1), Sr = /^[a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137-\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148-\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C-\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA-\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9-\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC-\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF-\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F-\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0-\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB-\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE-\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6-\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FC7\u1FD0-\u1FD3\u1FD6-\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6-\u1FF7\u210A\u210E-\u210F\u2113\u212F\u2134\u2139\u213C-\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65-\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73-\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3-\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A]/, Ir = N([["a", "z"], "µ", ["ß", "ö"], ["ø", "ÿ"], "ā", "ă", "ą", "ć", "ĉ", "ċ", "č", "ď", "đ", "ē", "ĕ", "ė", "ę", "ě", "ĝ", "ğ", "ġ", "ģ", "ĥ", "ħ", "ĩ", "ī", "ĭ", "į", "ı", "ĳ", "ĵ", ["ķ", "ĸ"], "ĺ", "ļ", "ľ", "ŀ", "ł", "ń", "ņ", ["ň", "ŉ"], "ŋ", "ō", "ŏ", "ő", "œ", "ŕ", "ŗ", "ř", "ś", "ŝ", "ş", "š", "ţ", "ť", "ŧ", "ũ", "ū", "ŭ", "ů", "ű", "ų", "ŵ", "ŷ", "ź", "ż", ["ž", "ƀ"], "ƃ", "ƅ", "ƈ", ["ƌ", "ƍ"], "ƒ", "ƕ", ["ƙ", "ƛ"], "ƞ", "ơ", "ƣ", "ƥ", "ƨ", ["ƪ", "ƫ"], "ƭ", "ư", "ƴ", "ƶ", ["ƹ", "ƺ"], ["ƽ", "ƿ"], "ǆ", "ǉ", "ǌ", "ǎ", "ǐ", "ǒ", "ǔ", "ǖ", "ǘ", "ǚ", ["ǜ", "ǝ"], "ǟ", "ǡ", "ǣ", "ǥ", "ǧ", "ǩ", "ǫ", "ǭ", ["ǯ", "ǰ"], "ǳ", "ǵ", "ǹ", "ǻ", "ǽ", "ǿ", "ȁ", "ȃ", "ȅ", "ȇ", "ȉ", "ȋ", "ȍ", "ȏ", "ȑ", "ȓ", "ȕ", "ȗ", "ș", "ț", "ȝ", "ȟ", "ȡ", "ȣ", "ȥ", "ȧ", "ȩ", "ȫ", "ȭ", "ȯ", "ȱ", ["ȳ", "ȹ"], "ȼ", ["ȿ", "ɀ"], "ɂ", "ɇ", "ɉ", "ɋ", "ɍ", ["ɏ", "ʓ"], ["ʕ", "ʯ"], "ͱ", "ͳ", "ͷ", ["ͻ", "ͽ"], "ΐ", ["ά", "ώ"], ["ϐ", "ϑ"], ["ϕ", "ϗ"], "ϙ", "ϛ", "ϝ", "ϟ", "ϡ", "ϣ", "ϥ", "ϧ", "ϩ", "ϫ", "ϭ", ["ϯ", "ϳ"], "ϵ", "ϸ", ["ϻ", "ϼ"], ["а", "џ"], "ѡ", "ѣ", "ѥ", "ѧ", "ѩ", "ѫ", "ѭ", "ѯ", "ѱ", "ѳ", "ѵ", "ѷ", "ѹ", "ѻ", "ѽ", "ѿ", "ҁ", "ҋ", "ҍ", "ҏ", "ґ", "ғ", "ҕ", "җ", "ҙ", "қ", "ҝ", "ҟ", "ҡ", "ң", "ҥ", "ҧ", "ҩ", "ҫ", "ҭ", "ү", "ұ", "ҳ", "ҵ", "ҷ", "ҹ", "һ", "ҽ", "ҿ", "ӂ", "ӄ", "ӆ", "ӈ", "ӊ", "ӌ", ["ӎ", "ӏ"], "ӑ", "ӓ", "ӕ", "ӗ", "ә", "ӛ", "ӝ", "ӟ", "ӡ", "ӣ", "ӥ", "ӧ", "ө", "ӫ", "ӭ", "ӯ", "ӱ", "ӳ", "ӵ", "ӷ", "ӹ", "ӻ", "ӽ", "ӿ", "ԁ", "ԃ", "ԅ", "ԇ", "ԉ", "ԋ", "ԍ", "ԏ", "ԑ", "ԓ", "ԕ", "ԗ", "ԙ", "ԛ", "ԝ", "ԟ", "ԡ", "ԣ", "ԥ", "ԧ", "ԩ", "ԫ", "ԭ", "ԯ", ["ա", "և"], ["ᏸ", "ᏽ"], ["ᴀ", "ᴫ"], ["ᵫ", "ᵷ"], ["ᵹ", "ᶚ"], "ḁ", "ḃ", "ḅ", "ḇ", "ḉ", "ḋ", "ḍ", "ḏ", "ḑ", "ḓ", "ḕ", "ḗ", "ḙ", "ḛ", "ḝ", "ḟ", "ḡ", "ḣ", "ḥ", "ḧ", "ḩ", "ḫ", "ḭ", "ḯ", "ḱ", "ḳ", "ḵ", "ḷ", "ḹ", "ḻ", "ḽ", "ḿ", "ṁ", "ṃ", "ṅ", "ṇ", "ṉ", "ṋ", "ṍ", "ṏ", "ṑ", "ṓ", "ṕ", "ṗ", "ṙ", "ṛ", "ṝ", "ṟ", "ṡ", "ṣ", "ṥ", "ṧ", "ṩ", "ṫ", "ṭ", "ṯ", "ṱ", "ṳ", "ṵ", "ṷ", "ṹ", "ṻ", "ṽ", "ṿ", "ẁ", "ẃ", "ẅ", "ẇ", "ẉ", "ẋ", "ẍ", "ẏ", "ẑ", "ẓ", ["ẕ", "ẝ"], "ẟ", "ạ", "ả", "ấ", "ầ", "ẩ", "ẫ", "ậ", "ắ", "ằ", "ẳ", "ẵ", "ặ", "ẹ", "ẻ", "ẽ", "ế", "ề", "ể", "ễ", "ệ", "ỉ", "ị", "ọ", "ỏ", "ố", "ồ", "ổ", "ỗ", "ộ", "ớ", "ờ", "ở", "ỡ", "ợ", "ụ", "ủ", "ứ", "ừ", "ử", "ữ", "ự", "ỳ", "ỵ", "ỷ", "ỹ", "ỻ", "ỽ", ["ỿ", "ἇ"], ["ἐ", "ἕ"], ["ἠ", "ἧ"], ["ἰ", "ἷ"], ["ὀ", "ὅ"], ["ὐ", "ὗ"], ["ὠ", "ὧ"], ["ὰ", "ώ"], ["ᾀ", "ᾇ"], ["ᾐ", "ᾗ"], ["ᾠ", "ᾧ"], ["ᾰ", "ᾴ"], ["ᾶ", "ᾷ"], "ι", ["ῂ", "ῄ"], ["ῆ", "ῇ"], ["ῐ", "ΐ"], ["ῖ", "ῗ"], ["ῠ", "ῧ"], ["ῲ", "ῴ"], ["ῶ", "ῷ"], "ℊ", ["ℎ", "ℏ"], "ℓ", "ℯ", "ℴ", "ℹ", ["ℼ", "ℽ"], ["ⅆ", "ⅉ"], "ⅎ", "ↄ", ["ⰰ", "ⱞ"], "ⱡ", ["ⱥ", "ⱦ"], "ⱨ", "ⱪ", "ⱬ", "ⱱ", ["ⱳ", "ⱴ"], ["ⱶ", "ⱻ"], "ⲁ", "ⲃ", "ⲅ", "ⲇ", "ⲉ", "ⲋ", "ⲍ", "ⲏ", "ⲑ", "ⲓ", "ⲕ", "ⲗ", "ⲙ", "ⲛ", "ⲝ", "ⲟ", "ⲡ", "ⲣ", "ⲥ", "ⲧ", "ⲩ", "ⲫ", "ⲭ", "ⲯ", "ⲱ", "ⲳ", "ⲵ", "ⲷ", "ⲹ", "ⲻ", "ⲽ", "ⲿ", "ⳁ", "ⳃ", "ⳅ", "ⳇ", "ⳉ", "ⳋ", "ⳍ", "ⳏ", "ⳑ", "ⳓ", "ⳕ", "ⳗ", "ⳙ", "ⳛ", "ⳝ", "ⳟ", "ⳡ", ["ⳣ", "ⳤ"], "ⳬ", "ⳮ", "ⳳ", ["ⴀ", "ⴥ"], "ⴧ", "ⴭ", "ꙁ", "ꙃ", "ꙅ", "ꙇ", "ꙉ", "ꙋ", "ꙍ", "ꙏ", "ꙑ", "ꙓ", "ꙕ", "ꙗ", "ꙙ", "ꙛ", "ꙝ", "ꙟ", "ꙡ", "ꙣ", "ꙥ", "ꙧ", "ꙩ", "ꙫ", "ꙭ", "ꚁ", "ꚃ", "ꚅ", "ꚇ", "ꚉ", "ꚋ", "ꚍ", "ꚏ", "ꚑ", "ꚓ", "ꚕ", "ꚗ", "ꚙ", "ꚛ", "ꜣ", "ꜥ", "ꜧ", "ꜩ", "ꜫ", "ꜭ", ["ꜯ", "ꜱ"], "ꜳ", "ꜵ", "ꜷ", "ꜹ", "ꜻ", "ꜽ", "ꜿ", "ꝁ", "ꝃ", "ꝅ", "ꝇ", "ꝉ", "ꝋ", "ꝍ", "ꝏ", "ꝑ", "ꝓ", "ꝕ", "ꝗ", "ꝙ", "ꝛ", "ꝝ", "ꝟ", "ꝡ", "ꝣ", "ꝥ", "ꝧ", "ꝩ", "ꝫ", "ꝭ", "ꝯ", ["ꝱ", "ꝸ"], "ꝺ", "ꝼ", "ꝿ", "ꞁ", "ꞃ", "ꞅ", "ꞇ", "ꞌ", "ꞎ", "ꞑ", ["ꞓ", "ꞕ"], "ꞗ", "ꞙ", "ꞛ", "ꞝ", "ꞟ", "ꞡ", "ꞣ", "ꞥ", "ꞧ", "ꞩ", "ꞵ", "ꞷ", "ꟺ", ["ꬰ", "ꭚ"], ["ꭠ", "ꭥ"], ["ꭰ", "ꮿ"], ["ﬀ", "ﬆ"], ["ﬓ", "ﬗ"], ["ａ", "ｚ"]], !1, !1), Or = /^[\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5-\u06E6\u07F4-\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C-\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D-\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C-\uA69D\uA717-\uA71F\uA770\uA788\uA7F8-\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3-\uAAF4\uAB5C-\uAB5F\uFF70\uFF9E-\uFF9F]/, Tr = N([["ʰ", "ˁ"], ["ˆ", "ˑ"], ["ˠ", "ˤ"], "ˬ", "ˮ", "ʹ", "ͺ", "ՙ", "ـ", ["ۥ", "ۦ"], ["ߴ", "ߵ"], "ߺ", "ࠚ", "ࠤ", "ࠨ", "ॱ", "ๆ", "ໆ", "ჼ", "ៗ", "ᡃ", "ᪧ", ["ᱸ", "ᱽ"], ["ᴬ", "ᵪ"], "ᵸ", ["ᶛ", "ᶿ"], "ⁱ", "ⁿ", ["ₐ", "ₜ"], ["ⱼ", "ⱽ"], "ⵯ", "ⸯ", "々", ["〱", "〵"], "〻", ["ゝ", "ゞ"], ["ー", "ヾ"], "ꀕ", ["ꓸ", "ꓽ"], "ꘌ", "ꙿ", ["ꚜ", "ꚝ"], ["ꜗ", "ꜟ"], "ꝰ", "ꞈ", ["ꟸ", "ꟹ"], "ꧏ", "ꧦ", "ꩰ", "ꫝ", ["ꫳ", "ꫴ"], ["ꭜ", "ꭟ"], "ｰ", ["ﾞ", "ﾟ"]], !1, !1), Lr = /^[\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05F0-\u05F2\u0620-\u063F\u0641-\u064A\u066E-\u066F\u0671-\u06D3\u06D5\u06EE-\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC-\u09DD\u09DF-\u09E1\u09F0-\u09F1\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33\u0A35-\u0A36\u0A38-\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0-\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F-\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B5C-\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60-\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0-\u0CE1\u0CF1-\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45\u0E81-\u0E82\u0E84\u0E87-\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065-\u1066\u106E-\u1070\u1075-\u1081\u108E\u10D0-\u10FA\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE-\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5-\u1CF6\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A-\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40-\uFB41\uFB43-\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, qr = N(["ª", "º", "ƻ", ["ǀ", "ǃ"], "ʔ", ["א", "ת"], ["װ", "ײ"], ["ؠ", "ؿ"], ["ف", "ي"], ["ٮ", "ٯ"], ["ٱ", "ۓ"], "ە", ["ۮ", "ۯ"], ["ۺ", "ۼ"], "ۿ", "ܐ", ["ܒ", "ܯ"], ["ݍ", "ޥ"], "ޱ", ["ߊ", "ߪ"], ["ࠀ", "ࠕ"], ["ࡀ", "ࡘ"], ["ࢠ", "ࢴ"], ["ऄ", "ह"], "ऽ", "ॐ", ["क़", "ॡ"], ["ॲ", "ঀ"], ["অ", "ঌ"], ["এ", "ঐ"], ["ও", "ন"], ["প", "র"], "ল", ["শ", "হ"], "ঽ", "ৎ", ["ড়", "ঢ়"], ["য়", "ৡ"], ["ৰ", "ৱ"], ["ਅ", "ਊ"], ["ਏ", "ਐ"], ["ਓ", "ਨ"], ["ਪ", "ਰ"], ["ਲ", "ਲ਼"], ["ਵ", "ਸ਼"], ["ਸ", "ਹ"], ["ਖ਼", "ੜ"], "ਫ਼", ["ੲ", "ੴ"], ["અ", "ઍ"], ["એ", "ઑ"], ["ઓ", "ન"], ["પ", "ર"], ["લ", "ળ"], ["વ", "હ"], "ઽ", "ૐ", ["ૠ", "ૡ"], "ૹ", ["ଅ", "ଌ"], ["ଏ", "ଐ"], ["ଓ", "ନ"], ["ପ", "ର"], ["ଲ", "ଳ"], ["ଵ", "ହ"], "ଽ", ["ଡ଼", "ଢ଼"], ["ୟ", "ୡ"], "ୱ", "ஃ", ["அ", "ஊ"], ["எ", "ஐ"], ["ஒ", "க"], ["ங", "ச"], "ஜ", ["ஞ", "ட"], ["ண", "த"], ["ந", "ப"], ["ம", "ஹ"], "ௐ", ["అ", "ఌ"], ["ఎ", "ఐ"], ["ఒ", "న"], ["ప", "హ"], "ఽ", ["ౘ", "ౚ"], ["ౠ", "ౡ"], ["ಅ", "ಌ"], ["ಎ", "ಐ"], ["ಒ", "ನ"], ["ಪ", "ಳ"], ["ವ", "ಹ"], "ಽ", "ೞ", ["ೠ", "ೡ"], ["ೱ", "ೲ"], ["അ", "ഌ"], ["എ", "ഐ"], ["ഒ", "ഺ"], "ഽ", "ൎ", ["ൟ", "ൡ"], ["ൺ", "ൿ"], ["අ", "ඖ"], ["ක", "න"], ["ඳ", "ර"], "ල", ["ව", "ෆ"], ["ก", "ะ"], ["า", "ำ"], ["เ", "ๅ"], ["ກ", "ຂ"], "ຄ", ["ງ", "ຈ"], "ຊ", "ຍ", ["ດ", "ທ"], ["ນ", "ຟ"], ["ມ", "ຣ"], "ລ", "ວ", ["ສ", "ຫ"], ["ອ", "ະ"], ["າ", "ຳ"], "ຽ", ["ເ", "ໄ"], ["ໜ", "ໟ"], "ༀ", ["ཀ", "ཇ"], ["ཉ", "ཬ"], ["ྈ", "ྌ"], ["က", "ဪ"], "ဿ", ["ၐ", "ၕ"], ["ၚ", "ၝ"], "ၡ", ["ၥ", "ၦ"], ["ၮ", "ၰ"], ["ၵ", "ႁ"], "ႎ", ["ა", "ჺ"], ["ჽ", "ቈ"], ["ቊ", "ቍ"], ["ቐ", "ቖ"], "ቘ", ["ቚ", "ቝ"], ["በ", "ኈ"], ["ኊ", "ኍ"], ["ነ", "ኰ"], ["ኲ", "ኵ"], ["ኸ", "ኾ"], "ዀ", ["ዂ", "ዅ"], ["ወ", "ዖ"], ["ዘ", "ጐ"], ["ጒ", "ጕ"], ["ጘ", "ፚ"], ["ᎀ", "ᎏ"], ["ᐁ", "ᙬ"], ["ᙯ", "ᙿ"], ["ᚁ", "ᚚ"], ["ᚠ", "ᛪ"], ["ᛱ", "ᛸ"], ["ᜀ", "ᜌ"], ["ᜎ", "ᜑ"], ["ᜠ", "ᜱ"], ["ᝀ", "ᝑ"], ["ᝠ", "ᝬ"], ["ᝮ", "ᝰ"], ["ក", "ឳ"], "ៜ", ["ᠠ", "ᡂ"], ["ᡄ", "ᡷ"], ["ᢀ", "ᢨ"], "ᢪ", ["ᢰ", "ᣵ"], ["ᤀ", "ᤞ"], ["ᥐ", "ᥭ"], ["ᥰ", "ᥴ"], ["ᦀ", "ᦫ"], ["ᦰ", "ᧉ"], ["ᨀ", "ᨖ"], ["ᨠ", "ᩔ"], ["ᬅ", "ᬳ"], ["ᭅ", "ᭋ"], ["ᮃ", "ᮠ"], ["ᮮ", "ᮯ"], ["ᮺ", "ᯥ"], ["ᰀ", "ᰣ"], ["ᱍ", "ᱏ"], ["ᱚ", "ᱷ"], ["ᳩ", "ᳬ"], ["ᳮ", "ᳱ"], ["ᳵ", "ᳶ"], ["ℵ", "ℸ"], ["ⴰ", "ⵧ"], ["ⶀ", "ⶖ"], ["ⶠ", "ⶦ"], ["ⶨ", "ⶮ"], ["ⶰ", "ⶶ"], ["ⶸ", "ⶾ"], ["ⷀ", "ⷆ"], ["ⷈ", "ⷎ"], ["ⷐ", "ⷖ"], ["ⷘ", "ⷞ"], "〆", "〼", ["ぁ", "ゖ"], "ゟ", ["ァ", "ヺ"], "ヿ", ["ㄅ", "ㄭ"], ["ㄱ", "ㆎ"], ["ㆠ", "ㆺ"], ["ㇰ", "ㇿ"], ["㐀", "䶵"], ["一", "鿕"], ["ꀀ", "ꀔ"], ["ꀖ", "ꒌ"], ["ꓐ", "ꓷ"], ["ꔀ", "ꘋ"], ["ꘐ", "ꘟ"], ["ꘪ", "ꘫ"], "ꙮ", ["ꚠ", "ꛥ"], "ꞏ", "ꟷ", ["ꟻ", "ꠁ"], ["ꠃ", "ꠅ"], ["ꠇ", "ꠊ"], ["ꠌ", "ꠢ"], ["ꡀ", "ꡳ"], ["ꢂ", "ꢳ"], ["ꣲ", "ꣷ"], "ꣻ", "ꣽ", ["ꤊ", "ꤥ"], ["ꤰ", "ꥆ"], ["ꥠ", "ꥼ"], ["ꦄ", "ꦲ"], ["ꧠ", "ꧤ"], ["ꧧ", "ꧯ"], ["ꧺ", "ꧾ"], ["ꨀ", "ꨨ"], ["ꩀ", "ꩂ"], ["ꩄ", "ꩋ"], ["ꩠ", "ꩯ"], ["ꩱ", "ꩶ"], "ꩺ", ["ꩾ", "ꪯ"], "ꪱ", ["ꪵ", "ꪶ"], ["ꪹ", "ꪽ"], "ꫀ", "ꫂ", ["ꫛ", "ꫜ"], ["ꫠ", "ꫪ"], "ꫲ", ["ꬁ", "ꬆ"], ["ꬉ", "ꬎ"], ["ꬑ", "ꬖ"], ["ꬠ", "ꬦ"], ["ꬨ", "ꬮ"], ["ꯀ", "ꯢ"], ["가", "힣"], ["ힰ", "ퟆ"], ["ퟋ", "ퟻ"], ["豈", "舘"], ["並", "龎"], "יִ", ["ײַ", "ﬨ"], ["שׁ", "זּ"], ["טּ", "לּ"], "מּ", ["נּ", "סּ"], ["ףּ", "פּ"], ["צּ", "ﮱ"], ["ﯓ", "ﴽ"], ["ﵐ", "ﶏ"], ["ﶒ", "ﷇ"], ["ﷰ", "ﷻ"], ["ﹰ", "ﹴ"], ["ﹶ", "ﻼ"], ["ｦ", "ｯ"], ["ｱ", "ﾝ"], ["ﾠ", "ﾾ"], ["ￂ", "ￇ"], ["ￊ", "ￏ"], ["ￒ", "ￗ"], ["ￚ", "ￜ"]], !1, !1), jr = /^[\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC]/, wr = N(["ǅ", "ǈ", "ǋ", "ǲ", ["ᾈ", "ᾏ"], ["ᾘ", "ᾟ"], ["ᾨ", "ᾯ"], "ᾼ", "ῌ", "ῼ"], !1, !1), Nr = /^[A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178-\u0179\u017B\u017D\u0181-\u0182\u0184\u0186-\u0187\u0189-\u018B\u018E-\u0191\u0193-\u0194\u0196-\u0198\u019C-\u019D\u019F-\u01A0\u01A2\u01A4\u01A6-\u01A7\u01A9\u01AC\u01AE-\u01AF\u01B1-\u01B3\u01B5\u01B7-\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A-\u023B\u023D-\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E-\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9-\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0-\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E-\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D-\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A]/, Ur = N([["A", "Z"], ["À", "Ö"], ["Ø", "Þ"], "Ā", "Ă", "Ą", "Ć", "Ĉ", "Ċ", "Č", "Ď", "Đ", "Ē", "Ĕ", "Ė", "Ę", "Ě", "Ĝ", "Ğ", "Ġ", "Ģ", "Ĥ", "Ħ", "Ĩ", "Ī", "Ĭ", "Į", "İ", "Ĳ", "Ĵ", "Ķ", "Ĺ", "Ļ", "Ľ", "Ŀ", "Ł", "Ń", "Ņ", "Ň", "Ŋ", "Ō", "Ŏ", "Ő", "Œ", "Ŕ", "Ŗ", "Ř", "Ś", "Ŝ", "Ş", "Š", "Ţ", "Ť", "Ŧ", "Ũ", "Ū", "Ŭ", "Ů", "Ű", "Ų", "Ŵ", "Ŷ", ["Ÿ", "Ź"], "Ż", "Ž", ["Ɓ", "Ƃ"], "Ƅ", ["Ɔ", "Ƈ"], ["Ɖ", "Ƌ"], ["Ǝ", "Ƒ"], ["Ɠ", "Ɣ"], ["Ɩ", "Ƙ"], ["Ɯ", "Ɲ"], ["Ɵ", "Ơ"], "Ƣ", "Ƥ", ["Ʀ", "Ƨ"], "Ʃ", "Ƭ", ["Ʈ", "Ư"], ["Ʊ", "Ƴ"], "Ƶ", ["Ʒ", "Ƹ"], "Ƽ", "Ǆ", "Ǉ", "Ǌ", "Ǎ", "Ǐ", "Ǒ", "Ǔ", "Ǖ", "Ǘ", "Ǚ", "Ǜ", "Ǟ", "Ǡ", "Ǣ", "Ǥ", "Ǧ", "Ǩ", "Ǫ", "Ǭ", "Ǯ", "Ǳ", "Ǵ", ["Ƕ", "Ǹ"], "Ǻ", "Ǽ", "Ǿ", "Ȁ", "Ȃ", "Ȅ", "Ȇ", "Ȉ", "Ȋ", "Ȍ", "Ȏ", "Ȑ", "Ȓ", "Ȕ", "Ȗ", "Ș", "Ț", "Ȝ", "Ȟ", "Ƞ", "Ȣ", "Ȥ", "Ȧ", "Ȩ", "Ȫ", "Ȭ", "Ȯ", "Ȱ", "Ȳ", ["Ⱥ", "Ȼ"], ["Ƚ", "Ⱦ"], "Ɂ", ["Ƀ", "Ɇ"], "Ɉ", "Ɋ", "Ɍ", "Ɏ", "Ͱ", "Ͳ", "Ͷ", "Ϳ", "Ά", ["Έ", "Ί"], "Ό", ["Ύ", "Ώ"], ["Α", "Ρ"], ["Σ", "Ϋ"], "Ϗ", ["ϒ", "ϔ"], "Ϙ", "Ϛ", "Ϝ", "Ϟ", "Ϡ", "Ϣ", "Ϥ", "Ϧ", "Ϩ", "Ϫ", "Ϭ", "Ϯ", "ϴ", "Ϸ", ["Ϲ", "Ϻ"], ["Ͻ", "Я"], "Ѡ", "Ѣ", "Ѥ", "Ѧ", "Ѩ", "Ѫ", "Ѭ", "Ѯ", "Ѱ", "Ѳ", "Ѵ", "Ѷ", "Ѹ", "Ѻ", "Ѽ", "Ѿ", "Ҁ", "Ҋ", "Ҍ", "Ҏ", "Ґ", "Ғ", "Ҕ", "Җ", "Ҙ", "Қ", "Ҝ", "Ҟ", "Ҡ", "Ң", "Ҥ", "Ҧ", "Ҩ", "Ҫ", "Ҭ", "Ү", "Ұ", "Ҳ", "Ҵ", "Ҷ", "Ҹ", "Һ", "Ҽ", "Ҿ", ["Ӏ", "Ӂ"], "Ӄ", "Ӆ", "Ӈ", "Ӊ", "Ӌ", "Ӎ", "Ӑ", "Ӓ", "Ӕ", "Ӗ", "Ә", "Ӛ", "Ӝ", "Ӟ", "Ӡ", "Ӣ", "Ӥ", "Ӧ", "Ө", "Ӫ", "Ӭ", "Ӯ", "Ӱ", "Ӳ", "Ӵ", "Ӷ", "Ӹ", "Ӻ", "Ӽ", "Ӿ", "Ԁ", "Ԃ", "Ԅ", "Ԇ", "Ԉ", "Ԋ", "Ԍ", "Ԏ", "Ԑ", "Ԓ", "Ԕ", "Ԗ", "Ԙ", "Ԛ", "Ԝ", "Ԟ", "Ԡ", "Ԣ", "Ԥ", "Ԧ", "Ԩ", "Ԫ", "Ԭ", "Ԯ", ["Ա", "Ֆ"], ["Ⴀ", "Ⴥ"], "Ⴧ", "Ⴭ", ["Ꭰ", "Ᏽ"], "Ḁ", "Ḃ", "Ḅ", "Ḇ", "Ḉ", "Ḋ", "Ḍ", "Ḏ", "Ḑ", "Ḓ", "Ḕ", "Ḗ", "Ḙ", "Ḛ", "Ḝ", "Ḟ", "Ḡ", "Ḣ", "Ḥ", "Ḧ", "Ḩ", "Ḫ", "Ḭ", "Ḯ", "Ḱ", "Ḳ", "Ḵ", "Ḷ", "Ḹ", "Ḻ", "Ḽ", "Ḿ", "Ṁ", "Ṃ", "Ṅ", "Ṇ", "Ṉ", "Ṋ", "Ṍ", "Ṏ", "Ṑ", "Ṓ", "Ṕ", "Ṗ", "Ṙ", "Ṛ", "Ṝ", "Ṟ", "Ṡ", "Ṣ", "Ṥ", "Ṧ", "Ṩ", "Ṫ", "Ṭ", "Ṯ", "Ṱ", "Ṳ", "Ṵ", "Ṷ", "Ṹ", "Ṻ", "Ṽ", "Ṿ", "Ẁ", "Ẃ", "Ẅ", "Ẇ", "Ẉ", "Ẋ", "Ẍ", "Ẏ", "Ẑ", "Ẓ", "Ẕ", "ẞ", "Ạ", "Ả", "Ấ", "Ầ", "Ẩ", "Ẫ", "Ậ", "Ắ", "Ằ", "Ẳ", "Ẵ", "Ặ", "Ẹ", "Ẻ", "Ẽ", "Ế", "Ề", "Ể", "Ễ", "Ệ", "Ỉ", "Ị", "Ọ", "Ỏ", "Ố", "Ồ", "Ổ", "Ỗ", "Ộ", "Ớ", "Ờ", "Ở", "Ỡ", "Ợ", "Ụ", "Ủ", "Ứ", "Ừ", "Ử", "Ữ", "Ự", "Ỳ", "Ỵ", "Ỷ", "Ỹ", "Ỻ", "Ỽ", "Ỿ", ["Ἀ", "Ἇ"], ["Ἐ", "Ἕ"], ["Ἠ", "Ἧ"], ["Ἰ", "Ἷ"], ["Ὀ", "Ὅ"], "Ὑ", "Ὓ", "Ὕ", "Ὗ", ["Ὠ", "Ὧ"], ["Ᾰ", "Ά"], ["Ὲ", "Ή"], ["Ῐ", "Ί"], ["Ῠ", "Ῥ"], ["Ὸ", "Ώ"], "ℂ", "ℇ", ["ℋ", "ℍ"], ["ℐ", "ℒ"], "ℕ", ["ℙ", "ℝ"], "ℤ", "Ω", "ℨ", ["K", "ℭ"], ["ℰ", "ℳ"], ["ℾ", "ℿ"], "ⅅ", "Ↄ", ["Ⰰ", "Ⱞ"], "Ⱡ", ["Ɫ", "Ɽ"], "Ⱨ", "Ⱪ", "Ⱬ", ["Ɑ", "Ɒ"], "Ⱳ", "Ⱶ", ["Ȿ", "Ⲁ"], "Ⲃ", "Ⲅ", "Ⲇ", "Ⲉ", "Ⲋ", "Ⲍ", "Ⲏ", "Ⲑ", "Ⲓ", "Ⲕ", "Ⲗ", "Ⲙ", "Ⲛ", "Ⲝ", "Ⲟ", "Ⲡ", "Ⲣ", "Ⲥ", "Ⲧ", "Ⲩ", "Ⲫ", "Ⲭ", "Ⲯ", "Ⲱ", "Ⲳ", "Ⲵ", "Ⲷ", "Ⲹ", "Ⲻ", "Ⲽ", "Ⲿ", "Ⳁ", "Ⳃ", "Ⳅ", "Ⳇ", "Ⳉ", "Ⳋ", "Ⳍ", "Ⳏ", "Ⳑ", "Ⳓ", "Ⳕ", "Ⳗ", "Ⳙ", "Ⳛ", "Ⳝ", "Ⳟ", "Ⳡ", "Ⳣ", "Ⳬ", "Ⳮ", "Ⳳ", "Ꙁ", "Ꙃ", "Ꙅ", "Ꙇ", "Ꙉ", "Ꙋ", "Ꙍ", "Ꙏ", "Ꙑ", "Ꙓ", "Ꙕ", "Ꙗ", "Ꙙ", "Ꙛ", "Ꙝ", "Ꙟ", "Ꙡ", "Ꙣ", "Ꙥ", "Ꙧ", "Ꙩ", "Ꙫ", "Ꙭ", "Ꚁ", "Ꚃ", "Ꚅ", "Ꚇ", "Ꚉ", "Ꚋ", "Ꚍ", "Ꚏ", "Ꚑ", "Ꚓ", "Ꚕ", "Ꚗ", "Ꚙ", "Ꚛ", "Ꜣ", "Ꜥ", "Ꜧ", "Ꜩ", "Ꜫ", "Ꜭ", "Ꜯ", "Ꜳ", "Ꜵ", "Ꜷ", "Ꜹ", "Ꜻ", "Ꜽ", "Ꜿ", "Ꝁ", "Ꝃ", "Ꝅ", "Ꝇ", "Ꝉ", "Ꝋ", "Ꝍ", "Ꝏ", "Ꝑ", "Ꝓ", "Ꝕ", "Ꝗ", "Ꝙ", "Ꝛ", "Ꝝ", "Ꝟ", "Ꝡ", "Ꝣ", "Ꝥ", "Ꝧ", "Ꝩ", "Ꝫ", "Ꝭ", "Ꝯ", "Ꝺ", "Ꝼ", ["Ᵹ", "Ꝿ"], "Ꞁ", "Ꞃ", "Ꞅ", "Ꞇ", "Ꞌ", "Ɥ", "Ꞑ", "Ꞓ", "Ꞗ", "Ꞙ", "Ꞛ", "Ꞝ", "Ꞟ", "Ꞡ", "Ꞣ", "Ꞥ", "Ꞧ", "Ꞩ", ["Ɦ", "Ɬ"], ["Ʞ", "Ꞵ"], "Ꞷ", ["Ａ", "Ｚ"]], !1, !1), Hr = /^[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0982-\u0983\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09D7\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0B02-\u0B03\u0B3E\u0B40\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD7\u0C01-\u0C03\u0C41-\u0C44\u0C82-\u0C83\u0CBE\u0CC0-\u0CC4\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0D02-\u0D03\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D57\u0D82-\u0D83\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DF2-\u0DF3\u0F3E-\u0F3F\u0F7F\u102B-\u102C\u1031\u1038\u103B-\u103C\u1056-\u1057\u1062-\u1064\u1067-\u106D\u1083-\u1084\u1087-\u108C\u108F\u109A-\u109C\u17B6\u17BE-\u17C5\u17C7-\u17C8\u1923-\u1926\u1929-\u192B\u1930-\u1931\u1933-\u1938\u1A19-\u1A1A\u1A55\u1A57\u1A61\u1A63-\u1A64\u1A6D-\u1A72\u1B04\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B82\u1BA1\u1BA6-\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1C24-\u1C2B\u1C34-\u1C35\u1CE1\u1CF2-\u1CF3\u302E-\u302F\uA823-\uA824\uA827\uA880-\uA881\uA8B4-\uA8C3\uA952-\uA953\uA983\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uAA2F-\uAA30\uAA33-\uAA34\uAA4D\uAA7B\uAA7D\uAAEB\uAAEE-\uAAEF\uAAF5\uABE3-\uABE4\uABE6-\uABE7\uABE9-\uABEA\uABEC]/, Gr = N(["ः", "ऻ", ["ा", "ी"], ["ॉ", "ौ"], ["ॎ", "ॏ"], ["ং", "ঃ"], ["া", "ী"], ["ে", "ৈ"], ["ো", "ৌ"], "ৗ", "ਃ", ["ਾ", "ੀ"], "ઃ", ["ા", "ી"], "ૉ", ["ો", "ૌ"], ["ଂ", "ଃ"], "ା", "ୀ", ["େ", "ୈ"], ["ୋ", "ୌ"], "ୗ", ["ா", "ி"], ["ு", "ூ"], ["ெ", "ை"], ["ொ", "ௌ"], "ௗ", ["ఁ", "ః"], ["ు", "ౄ"], ["ಂ", "ಃ"], "ಾ", ["ೀ", "ೄ"], ["ೇ", "ೈ"], ["ೊ", "ೋ"], ["ೕ", "ೖ"], ["ം", "ഃ"], ["ാ", "ീ"], ["െ", "ൈ"], ["ൊ", "ൌ"], "ൗ", ["ං", "ඃ"], ["ා", "ෑ"], ["ෘ", "ෟ"], ["ෲ", "ෳ"], ["༾", "༿"], "ཿ", ["ါ", "ာ"], "ေ", "း", ["ျ", "ြ"], ["ၖ", "ၗ"], ["ၢ", "ၤ"], ["ၧ", "ၭ"], ["ႃ", "ႄ"], ["ႇ", "ႌ"], "ႏ", ["ႚ", "ႜ"], "ា", ["ើ", "ៅ"], ["ះ", "ៈ"], ["ᤣ", "ᤦ"], ["ᤩ", "ᤫ"], ["ᤰ", "ᤱ"], ["ᤳ", "ᤸ"], ["ᨙ", "ᨚ"], "ᩕ", "ᩗ", "ᩡ", ["ᩣ", "ᩤ"], ["ᩭ", "ᩲ"], "ᬄ", "ᬵ", "ᬻ", ["ᬽ", "ᭁ"], ["ᭃ", "᭄"], "ᮂ", "ᮡ", ["ᮦ", "ᮧ"], "᮪", "ᯧ", ["ᯪ", "ᯬ"], "ᯮ", ["᯲", "᯳"], ["ᰤ", "ᰫ"], ["ᰴ", "ᰵ"], "᳡", ["ᳲ", "ᳳ"], ["〮", "〯"], ["ꠣ", "ꠤ"], "ꠧ", ["ꢀ", "ꢁ"], ["ꢴ", "ꣃ"], ["ꥒ", "꥓"], "ꦃ", ["ꦴ", "ꦵ"], ["ꦺ", "ꦻ"], ["ꦽ", "꧀"], ["ꨯ", "ꨰ"], ["ꨳ", "ꨴ"], "ꩍ", "ꩻ", "ꩽ", "ꫫ", ["ꫮ", "ꫯ"], "ꫵ", ["ꯣ", "ꯤ"], ["ꯦ", "ꯧ"], ["ꯩ", "ꯪ"], "꯬"], !1, !1), Mr = /^[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1-\u05C2\u05C4-\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7-\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962-\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2-\u09E3\u0A01-\u0A02\u0A3C\u0A41-\u0A42\u0A47-\u0A48\u0A4B-\u0A4D\u0A51\u0A70-\u0A71\u0A75\u0A81-\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7-\u0AC8\u0ACD\u0AE2-\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62-\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55-\u0C56\u0C62-\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC-\u0CCD\u0CE2-\u0CE3\u0D01\u0D41-\u0D44\u0D4D\u0D62-\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB-\u0EBC\u0EC8-\u0ECD\u0F18-\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86-\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039-\u103A\u103D-\u103E\u1058-\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085-\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17B4-\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193B\u1A17-\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80-\u1B81\u1BA2-\u1BA5\u1BA8-\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8-\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8-\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099-\u309A\uA66F\uA674-\uA67D\uA69E-\uA69F\uA6F0-\uA6F1\uA802\uA806\uA80B\uA825-\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31-\uAA32\uAA35-\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7-\uAAB8\uAABE-\uAABF\uAAC1\uAAEC-\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/, Vr = N([["̀", "ͯ"], ["҃", "҇"], ["֑", "ֽ"], "ֿ", ["ׁ", "ׂ"], ["ׄ", "ׅ"], "ׇ", ["ؐ", "ؚ"], ["ً", "ٟ"], "ٰ", ["ۖ", "ۜ"], ["۟", "ۤ"], ["ۧ", "ۨ"], ["۪", "ۭ"], "ܑ", ["ܰ", "݊"], ["ަ", "ް"], ["߫", "߳"], ["ࠖ", "࠙"], ["ࠛ", "ࠣ"], ["ࠥ", "ࠧ"], ["ࠩ", "࠭"], ["࡙", "࡛"], ["ࣣ", "ं"], "ऺ", "़", ["ु", "ै"], "्", ["॑", "ॗ"], ["ॢ", "ॣ"], "ঁ", "়", ["ু", "ৄ"], "্", ["ৢ", "ৣ"], ["ਁ", "ਂ"], "਼", ["ੁ", "ੂ"], ["ੇ", "ੈ"], ["ੋ", "੍"], "ੑ", ["ੰ", "ੱ"], "ੵ", ["ઁ", "ં"], "઼", ["ુ", "ૅ"], ["ે", "ૈ"], "્", ["ૢ", "ૣ"], "ଁ", "଼", "ି", ["ୁ", "ୄ"], "୍", "ୖ", ["ୢ", "ୣ"], "ஂ", "ீ", "்", "ఀ", ["ా", "ీ"], ["ె", "ై"], ["ొ", "్"], ["ౕ", "ౖ"], ["ౢ", "ౣ"], "ಁ", "಼", "ಿ", "ೆ", ["ೌ", "್"], ["ೢ", "ೣ"], "ഁ", ["ു", "ൄ"], "്", ["ൢ", "ൣ"], "්", ["ි", "ු"], "ූ", "ั", ["ิ", "ฺ"], ["็", "๎"], "ັ", ["ິ", "ູ"], ["ົ", "ຼ"], ["່", "ໍ"], ["༘", "༙"], "༵", "༷", "༹", ["ཱ", "ཾ"], ["ྀ", "྄"], ["྆", "྇"], ["ྍ", "ྗ"], ["ྙ", "ྼ"], "࿆", ["ိ", "ူ"], ["ဲ", "့"], ["္", "်"], ["ွ", "ှ"], ["ၘ", "ၙ"], ["ၞ", "ၠ"], ["ၱ", "ၴ"], "ႂ", ["ႅ", "ႆ"], "ႍ", "ႝ", ["፝", "፟"], ["ᜒ", "᜔"], ["ᜲ", "᜴"], ["ᝒ", "ᝓ"], ["ᝲ", "ᝳ"], ["឴", "឵"], ["ិ", "ួ"], "ំ", ["៉", "៓"], "៝", ["᠋", "᠍"], "ᢩ", ["ᤠ", "ᤢ"], ["ᤧ", "ᤨ"], "ᤲ", ["᤹", "᤻"], ["ᨗ", "ᨘ"], "ᨛ", "ᩖ", ["ᩘ", "ᩞ"], "᩠", "ᩢ", ["ᩥ", "ᩬ"], ["ᩳ", "᩼"], "᩿", ["᪰", "᪽"], ["ᬀ", "ᬃ"], "᬴", ["ᬶ", "ᬺ"], "ᬼ", "ᭂ", ["᭫", "᭳"], ["ᮀ", "ᮁ"], ["ᮢ", "ᮥ"], ["ᮨ", "ᮩ"], ["᮫", "ᮭ"], "᯦", ["ᯨ", "ᯩ"], "ᯭ", ["ᯯ", "ᯱ"], ["ᰬ", "ᰳ"], ["ᰶ", "᰷"], ["᳐", "᳒"], ["᳔", "᳠"], ["᳢", "᳨"], "᳭", "᳴", ["᳸", "᳹"], ["᷀", "᷵"], ["᷼", "᷿"], ["⃐", "⃜"], "⃡", ["⃥", "⃰"], ["⳯", "⳱"], "⵿", ["ⷠ", "ⷿ"], ["〪", "〭"], ["゙", "゚"], "꙯", ["ꙴ", "꙽"], ["ꚞ", "ꚟ"], ["꛰", "꛱"], "ꠂ", "꠆", "ꠋ", ["ꠥ", "ꠦ"], "꣄", ["꣠", "꣱"], ["ꤦ", "꤭"], ["ꥇ", "ꥑ"], ["ꦀ", "ꦂ"], "꦳", ["ꦶ", "ꦹ"], "ꦼ", "ꧥ", ["ꨩ", "ꨮ"], ["ꨱ", "ꨲ"], ["ꨵ", "ꨶ"], "ꩃ", "ꩌ", "ꩼ", "ꪰ", ["ꪲ", "ꪴ"], ["ꪷ", "ꪸ"], ["ꪾ", "꪿"], "꫁", ["ꫬ", "ꫭ"], "꫶", "ꯥ", "ꯨ", "꯭", "ﬞ", ["︀", "️"], ["︠", "︯"]], !1, !1), zr = /^[0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]/, Jr = N([["0", "9"], ["٠", "٩"], ["۰", "۹"], ["߀", "߉"], ["०", "९"], ["০", "৯"], ["੦", "੯"], ["૦", "૯"], ["୦", "୯"], ["௦", "௯"], ["౦", "౯"], ["೦", "೯"], ["൦", "൯"], ["෦", "෯"], ["๐", "๙"], ["໐", "໙"], ["༠", "༩"], ["၀", "၉"], ["႐", "႙"], ["០", "៩"], ["᠐", "᠙"], ["᥆", "᥏"], ["᧐", "᧙"], ["᪀", "᪉"], ["᪐", "᪙"], ["᭐", "᭙"], ["᮰", "᮹"], ["᱀", "᱉"], ["᱐", "᱙"], ["꘠", "꘩"], ["꣐", "꣙"], ["꤀", "꤉"], ["꧐", "꧙"], ["꧰", "꧹"], ["꩐", "꩙"], ["꯰", "꯹"], ["０", "９"]], !1, !1), Yr = /^[\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF]/, Wr = N([["ᛮ", "ᛰ"], ["Ⅰ", "ↂ"], ["ↅ", "ↈ"], "〇", ["〡", "〩"], ["〸", "〺"], ["ꛦ", "ꛯ"]], !1, !1), Xr = /^[_\u203F-\u2040\u2054\uFE33-\uFE34\uFE4D-\uFE4F\uFF3F]/, Zr = N(["_", ["‿", "⁀"], "⁔", ["︳", "︴"], ["﹍", "﹏"], "＿"], !1, !1), Kr = /^[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/, Qr = N([" ", " ", " ", [" ", " "], " ", " ", "　"], !1, !1), Mu = "break", us = g("break", !1), Vu = "case", es = g("case", !1), zu = "catch", rs = g("catch", !1), Ju = "class", ss = g("class", !1), Yu = "const", is = g("const", !1), Wu = "continue", ts = g("continue", !1), Xu = "debugger", ns = g("debugger", !1), Zu = "default", as = g("default", !1), Ku = "delete", As = g("delete", !1), Qu = "do", os = g("do", !1), ue = "else", cs = g("else", !1), ee = "enum", ps = g("enum", !1), re = "export", ls = g("export", !1), se = "extends", fs = g("extends", !1), ie = "false", Es = g("false", !1), te = "finally", Cs = g("finally", !1), ne = "for", Fs = g("for", !1), ae = "function", Bs = g("function", !1), Ae = "if", Ds = g("if", !1), oe = "import", gs = g("import", !1), ce = "instanceof", ds = g("instanceof", !1), pe = "in", hs = g("in", !1), le = "new", $s = g("new", !1), fe = "null", vs = g("null", !1), Ee = "return", ms = g("return", !1), Ce = "super", Rs = g("super", !1), Fe = "switch", bs = g("switch", !1), Be = "this", xs = g("this", !1), De = "throw", Ps = g("throw", !1), ge = "true", _s = g("true", !1), de = "try", ys = g("try", !1), he = "typeof", ks = g("typeof", !1), $e = "var", Ss = g("var", !1), ve = "void", Is = g("void", !1), me = "while", Os = g("while", !1), Re = "with", Ts = g("with", !1), Ls = ";", qs = g(";", !1), r = 0, R = 0, ou = [{ line: 1, column: 1 }], G = 0, gu = [], A = 0, cu;
    if ("startRule" in o) {
      if (!(o.startRule in B))
        throw new Error(`Can't start parsing from rule "` + o.startRule + '".');
      v = B[o.startRule];
    }
    function be() {
      return a.substring(R, r);
    }
    function w() {
      return pu(R, r);
    }
    function ws(u, i) {
      throw i = i !== void 0 ? i : pu(R, r), Hs(u, i);
    }
    function g(u, i) {
      return { type: "literal", text: u, ignoreCase: i };
    }
    function N(u, i, t) {
      return { type: "class", parts: u, inverted: i, ignoreCase: t };
    }
    function Ns() {
      return { type: "any" };
    }
    function Us() {
      return { type: "end" };
    }
    function J(u) {
      return { type: "other", description: u };
    }
    function xe(u) {
      var i = ou[u], t;
      if (i)
        return i;
      for (t = u - 1; !ou[t]; )
        t--;
      for (i = ou[t], i = {
        line: i.line,
        column: i.column
      }; t < u; )
        a.charCodeAt(t) === 10 ? (i.line++, i.column = 1) : i.column++, t++;
      return ou[u] = i, i;
    }
    function pu(u, i) {
      var t = xe(u), n = xe(i);
      return {
        start: {
          offset: u,
          line: t.line,
          column: t.column
        },
        end: {
          offset: i,
          line: n.line,
          column: n.column
        }
      };
    }
    function l(u) {
      r < G || (r > G && (G = r, gu = []), gu.push(u));
    }
    function Hs(u, i) {
      return new f(u, null, null, i);
    }
    function Gs(u, i, t) {
      return new f(
        f.buildMessage(u, i),
        u,
        i,
        t
      );
    }
    function Pe() {
      var u, i, t, n, p, E, y;
      if (u = r, i = O(), i !== e)
        if (t = r, n = Ms(), n !== e ? (p = O(), p !== e ? (n = [n, p], t = n) : (r = t, t = e)) : (r = t, t = e), t === e && (t = null), t !== e) {
          if (n = [], p = r, E = _e(), E !== e ? (y = O(), y !== e ? (E = [E, y], p = E) : (r = p, p = e)) : (r = p, p = e), p !== e)
            for (; p !== e; )
              n.push(p), p = r, E = _e(), E !== e ? (y = O(), y !== e ? (E = [E, y], p = E) : (r = p, p = e)) : (r = p, p = e);
          else
            n = e;
          n !== e ? (R = u, i = h(t, n), u = i) : (r = u, u = e);
        } else
          r = u, u = e;
      else
        r = u, u = e;
      return u;
    }
    function Ms() {
      var u, i, t;
      return u = r, i = bu(), i !== e ? (t = Me(), t !== e ? (R = u, i = $(i), u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function _e() {
      var u, i, t, n, p, E, y, q;
      return u = r, i = $u(), i !== e ? (t = O(), t !== e ? (n = r, p = vu(), p !== e ? (E = O(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e), n === e && (n = null), n !== e ? (a.charCodeAt(r) === 61 ? (p = k, r++) : (p = e, A === 0 && l(P)), p !== e ? (E = O(), E !== e ? (y = ye(), y !== e ? (q = Me(), q !== e ? (R = u, i = m(i, n, y), u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function ye() {
      var u, i, t, n, p, E, y, q;
      if (u = r, i = du(), i !== e) {
        for (t = [], n = r, p = O(), p !== e ? (a.charCodeAt(r) === 47 ? (E = _, r++) : (E = e, A === 0 && l(S)), E !== e ? (y = O(), y !== e ? (q = du(), q !== e ? (p = [p, E, y, q], n = p) : (r = n, n = e)) : (r = n, n = e)) : (r = n, n = e)) : (r = n, n = e); n !== e; )
          t.push(n), n = r, p = O(), p !== e ? (a.charCodeAt(r) === 47 ? (E = _, r++) : (E = e, A === 0 && l(S)), E !== e ? (y = O(), y !== e ? (q = du(), q !== e ? (p = [p, E, y, q], n = p) : (r = n, n = e)) : (r = n, n = e)) : (r = n, n = e)) : (r = n, n = e);
        t !== e ? (R = u, i = M(i, t), u = i) : (r = u, u = e);
      } else
        r = u, u = e;
      return u;
    }
    function du() {
      var u, i, t, n, p;
      return u = r, i = Vs(), i !== e ? (t = r, n = O(), n !== e ? (p = bu(), p !== e ? (n = [n, p], t = n) : (r = t, t = e)) : (r = t, t = e), t === e && (t = null), t !== e ? (R = u, i = K(i, t), u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function Vs() {
      var u, i, t, n, p, E;
      if (u = r, i = hu(), i !== e) {
        for (t = [], n = r, p = O(), p !== e ? (E = hu(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e); n !== e; )
          t.push(n), n = r, p = O(), p !== e ? (E = hu(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e);
        t !== e ? (R = u, i = Q(i, t), u = i) : (r = u, u = e);
      } else
        r = u, u = e;
      return u;
    }
    function hu() {
      var u, i, t, n, p, E;
      return u = r, i = Ks(), i !== e ? (t = O(), t !== e ? (a.charCodeAt(r) === 58 ? (n = j, r++) : (n = e, A === 0 && l(D)), n !== e ? (p = O(), p !== e ? (E = ke(), E !== e ? (R = u, i = d(i, E), u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e), u === e && (u = ke()), u;
    }
    function ke() {
      var u, i, t, n;
      return u = r, i = zs(), i !== e ? (t = O(), t !== e ? (n = Se(), n !== e ? (R = u, i = b(i, n), u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e), u === e && (u = Se()), u;
    }
    function zs() {
      var u;
      return a.charCodeAt(r) === 36 ? (u = T, r++) : (u = e, A === 0 && l(I)), u === e && (a.charCodeAt(r) === 38 ? (u = L, r++) : (u = e, A === 0 && l(Z)), u === e && (a.charCodeAt(r) === 33 ? (u = Pu, r++) : (u = e, A === 0 && l(_u)))), u;
    }
    function Se() {
      var u, i, t, n;
      return u = r, i = Ie(), i !== e ? (t = O(), t !== e ? (n = Js(), n !== e ? (R = u, i = Je(i, n), u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e), u === e && (u = Ie()), u;
    }
    function Js() {
      var u;
      return a.charCodeAt(r) === 63 ? (u = Ye, r++) : (u = e, A === 0 && l(We)), u === e && (a.charCodeAt(r) === 42 ? (u = Xe, r++) : (u = e, A === 0 && l(Ze)), u === e && (a.charCodeAt(r) === 43 ? (u = Ke, r++) : (u = e, A === 0 && l(Qe)))), u;
    }
    function Ie() {
      var u, i, t, n, p, E;
      return u = t1(), u === e && (u = n1(), u === e && (u = p1(), u === e && (u = Ys(), u === e && (u = Ws(), u === e && (u = r, a.charCodeAt(r) === 40 ? (i = u0, r++) : (i = e, A === 0 && l(e0)), i !== e ? (t = O(), t !== e ? (n = ye(), n !== e ? (p = O(), p !== e ? (a.charCodeAt(r) === 41 ? (E = r0, r++) : (E = e, A === 0 && l(s0)), E !== e ? (R = u, i = i0(n), u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e)))))), u;
    }
    function Ys() {
      var u, i, t, n, p, E, y, q;
      return u = r, i = $u(), i !== e ? (t = r, A++, n = r, p = O(), p !== e ? (E = r, y = vu(), y !== e ? (q = O(), q !== e ? (y = [y, q], E = y) : (r = E, E = e)) : (r = E, E = e), E === e && (E = null), E !== e ? (a.charCodeAt(r) === 61 ? (y = k, r++) : (y = e, A === 0 && l(P)), y !== e ? (p = [p, E, y], n = p) : (r = n, n = e)) : (r = n, n = e)) : (r = n, n = e), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (R = u, i = t0(i), u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function Ws() {
      var u, i, t, n;
      return u = r, i = Xs(), i !== e ? (t = O(), t !== e ? (n = bu(), n !== e ? (R = u, i = n0(i, n), u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function Xs() {
      var u;
      return a.charCodeAt(r) === 38 ? (u = L, r++) : (u = e, A === 0 && l(Z)), u === e && (a.charCodeAt(r) === 33 ? (u = Pu, r++) : (u = e, A === 0 && l(_u))), u;
    }
    function U() {
      var u;
      return a.length > r ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(yu)), u;
    }
    function lu() {
      var u;
      return A++, a.charCodeAt(r) === 9 ? (u = A0, r++) : (u = e, A === 0 && l(o0)), u === e && (a.charCodeAt(r) === 11 ? (u = c0, r++) : (u = e, A === 0 && l(p0)), u === e && (a.charCodeAt(r) === 12 ? (u = l0, r++) : (u = e, A === 0 && l(f0)), u === e && (a.charCodeAt(r) === 32 ? (u = E0, r++) : (u = e, A === 0 && l(C0)), u === e && (a.charCodeAt(r) === 160 ? (u = F0, r++) : (u = e, A === 0 && l(B0)), u === e && (a.charCodeAt(r) === 65279 ? (u = D0, r++) : (u = e, A === 0 && l(g0)), u === e && (u = $1())))))), A--, u === e && A === 0 && l(a0), u;
    }
    function Y() {
      var u;
      return d0.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(h0)), u;
    }
    function fu() {
      var u;
      return A++, a.charCodeAt(r) === 10 ? (u = v0, r++) : (u = e, A === 0 && l(m0)), u === e && (a.substr(r, 2) === ku ? (u = ku, r += 2) : (u = e, A === 0 && l(R0)), u === e && (a.charCodeAt(r) === 13 ? (u = b0, r++) : (u = e, A === 0 && l(x0)), u === e && (a.charCodeAt(r) === 8232 ? (u = P0, r++) : (u = e, A === 0 && l(_0)), u === e && (a.charCodeAt(r) === 8233 ? (u = y0, r++) : (u = e, A === 0 && l(k0)))))), A--, u === e && A === 0 && l($0), u;
    }
    function Oe() {
      var u;
      return A++, u = Zs(), u === e && (u = Le()), A--, u === e && A === 0 && l(S0), u;
    }
    function Zs() {
      var u, i, t, n, p, E;
      if (u = r, a.substr(r, 2) === uu ? (i = uu, r += 2) : (i = e, A === 0 && l(Su)), i !== e) {
        for (t = [], n = r, p = r, A++, a.substr(r, 2) === H ? (E = H, r += 2) : (E = e, A === 0 && l(W)), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e); n !== e; )
          t.push(n), n = r, p = r, A++, a.substr(r, 2) === H ? (E = H, r += 2) : (E = e, A === 0 && l(W)), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e);
        t !== e ? (a.substr(r, 2) === H ? (n = H, r += 2) : (n = e, A === 0 && l(W)), n !== e ? (i = [i, t, n], u = i) : (r = u, u = e)) : (r = u, u = e);
      } else
        r = u, u = e;
      return u;
    }
    function Te() {
      var u, i, t, n, p, E;
      if (u = r, a.substr(r, 2) === uu ? (i = uu, r += 2) : (i = e, A === 0 && l(Su)), i !== e) {
        for (t = [], n = r, p = r, A++, a.substr(r, 2) === H ? (E = H, r += 2) : (E = e, A === 0 && l(W)), E === e && (E = Y()), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e); n !== e; )
          t.push(n), n = r, p = r, A++, a.substr(r, 2) === H ? (E = H, r += 2) : (E = e, A === 0 && l(W)), E === e && (E = Y()), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e);
        t !== e ? (a.substr(r, 2) === H ? (n = H, r += 2) : (n = e, A === 0 && l(W)), n !== e ? (i = [i, t, n], u = i) : (r = u, u = e)) : (r = u, u = e);
      } else
        r = u, u = e;
      return u;
    }
    function Le() {
      var u, i, t, n, p, E;
      if (u = r, a.substr(r, 2) === Iu ? (i = Iu, r += 2) : (i = e, A === 0 && l(I0)), i !== e) {
        for (t = [], n = r, p = r, A++, E = Y(), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e); n !== e; )
          t.push(n), n = r, p = r, A++, E = Y(), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e);
        t !== e ? (i = [i, t], u = i) : (r = u, u = e);
      } else
        r = u, u = e;
      return u;
    }
    function Ks() {
      var u, i, t;
      return u = r, i = r, A++, t = e1(), A--, t === e ? i = void 0 : (r = i, i = e), i !== e ? (t = $u(), t !== e ? (R = u, i = O0(t), u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function $u() {
      var u, i, t, n;
      if (A++, u = r, i = qe(), i !== e) {
        for (t = [], n = x(); n !== e; )
          t.push(n), n = x();
        t !== e ? (R = u, i = L0(i, t), u = i) : (r = u, u = e);
      } else
        r = u, u = e;
      return A--, u === e && (i = e, A === 0 && l(T0)), u;
    }
    function qe() {
      var u, i, t;
      return u = Qs(), u === e && (a.charCodeAt(r) === 36 ? (u = T, r++) : (u = e, A === 0 && l(I)), u === e && (a.charCodeAt(r) === 95 ? (u = q0, r++) : (u = e, A === 0 && l(j0)), u === e && (u = r, a.charCodeAt(r) === 92 ? (i = V, r++) : (i = e, A === 0 && l(z)), i !== e ? (t = He(), t !== e ? (R = u, i = eu(t), u = i) : (r = u, u = e)) : (r = u, u = e)))), u;
    }
    function x() {
      var u;
      return u = qe(), u === e && (u = u1(), u === e && (u = g1(), u === e && (u = h1(), u === e && (a.charCodeAt(r) === 8204 ? (u = w0, r++) : (u = e, A === 0 && l(N0)), u === e && (a.charCodeAt(r) === 8205 ? (u = U0, r++) : (u = e, A === 0 && l(H0))))))), u;
    }
    function Qs() {
      var u;
      return u = F1(), u === e && (u = l1(), u === e && (u = C1(), u === e && (u = f1(), u === e && (u = E1(), u === e && (u = d1()))))), u;
    }
    function u1() {
      var u;
      return u = D1(), u === e && (u = B1()), u;
    }
    function e1() {
      var u;
      return u = r1(), u === e && (u = s1(), u === e && (u = z1(), u === e && (u = i1()))), u;
    }
    function r1() {
      var u;
      return u = v1(), u === e && (u = m1(), u === e && (u = R1(), u === e && (u = P1(), u === e && (u = _1(), u === e && (u = y1(), u === e && (u = k1(), u === e && (u = S1(), u === e && (u = I1(), u === e && (u = j1(), u === e && (u = w1(), u === e && (u = N1(), u === e && (u = U1(), u === e && (u = G1(), u === e && (u = M1(), u === e && (u = V1(), u === e && (u = J1(), u === e && (u = W1(), u === e && (u = X1(), u === e && (u = Z1(), u === e && (u = Q1(), u === e && (u = ui(), u === e && (u = ei(), u === e && (u = ri(), u === e && (u = si(), u === e && (u = ii()))))))))))))))))))))))))), u;
    }
    function s1() {
      var u;
      return u = b1(), u === e && (u = x1(), u === e && (u = O1(), u === e && (u = T1(), u === e && (u = L1(), u === e && (u = H1(), u === e && (u = Y1())))))), u;
    }
    function i1() {
      var u;
      return u = K1(), u === e && (u = q1()), u;
    }
    function t1() {
      var u, i, t;
      return A++, u = r, i = vu(), i !== e ? (a.charCodeAt(r) === 105 ? (t = Ou, r++) : (t = e, A === 0 && l(Tu)), t === e && (t = null), t !== e ? (R = u, i = M0(i, t), u = i) : (r = u, u = e)) : (r = u, u = e), A--, u === e && (i = e, A === 0 && l(G0)), u;
    }
    function vu() {
      var u, i, t, n;
      if (A++, u = r, a.charCodeAt(r) === 34 ? (i = ru, r++) : (i = e, A === 0 && l(su)), i !== e) {
        for (t = [], n = je(); n !== e; )
          t.push(n), n = je();
        t !== e ? (a.charCodeAt(r) === 34 ? (n = ru, r++) : (n = e, A === 0 && l(su)), n !== e ? (R = u, i = Lu(t), u = i) : (r = u, u = e)) : (r = u, u = e);
      } else
        r = u, u = e;
      if (u === e)
        if (u = r, a.charCodeAt(r) === 39 ? (i = iu, r++) : (i = e, A === 0 && l(tu)), i !== e) {
          for (t = [], n = we(); n !== e; )
            t.push(n), n = we();
          t !== e ? (a.charCodeAt(r) === 39 ? (n = iu, r++) : (n = e, A === 0 && l(tu)), n !== e ? (R = u, i = Lu(t), u = i) : (r = u, u = e)) : (r = u, u = e);
        } else
          r = u, u = e;
      return A--, u === e && (i = e, A === 0 && l(V0)), u;
    }
    function je() {
      var u, i, t;
      return u = r, i = r, A++, a.charCodeAt(r) === 34 ? (t = ru, r++) : (t = e, A === 0 && l(su)), t === e && (a.charCodeAt(r) === 92 ? (t = V, r++) : (t = e, A === 0 && l(z)), t === e && (t = Y())), A--, t === e ? i = void 0 : (r = i, i = e), i !== e ? (t = U(), t !== e ? (R = u, i = nu(), u = i) : (r = u, u = e)) : (r = u, u = e), u === e && (u = r, a.charCodeAt(r) === 92 ? (i = V, r++) : (i = e, A === 0 && l(z)), i !== e ? (t = Ru(), t !== e ? (R = u, i = eu(t), u = i) : (r = u, u = e)) : (r = u, u = e), u === e && (u = mu())), u;
    }
    function we() {
      var u, i, t;
      return u = r, i = r, A++, a.charCodeAt(r) === 39 ? (t = iu, r++) : (t = e, A === 0 && l(tu)), t === e && (a.charCodeAt(r) === 92 ? (t = V, r++) : (t = e, A === 0 && l(z)), t === e && (t = Y())), A--, t === e ? i = void 0 : (r = i, i = e), i !== e ? (t = U(), t !== e ? (R = u, i = nu(), u = i) : (r = u, u = e)) : (r = u, u = e), u === e && (u = r, a.charCodeAt(r) === 92 ? (i = V, r++) : (i = e, A === 0 && l(z)), i !== e ? (t = Ru(), t !== e ? (R = u, i = eu(t), u = i) : (r = u, u = e)) : (r = u, u = e), u === e && (u = mu())), u;
    }
    function n1() {
      var u, i, t, n, p, E;
      if (A++, u = r, a.charCodeAt(r) === 91 ? (i = J0, r++) : (i = e, A === 0 && l(Y0)), i !== e)
        if (a.charCodeAt(r) === 94 ? (t = W0, r++) : (t = e, A === 0 && l(X0)), t === e && (t = null), t !== e) {
          for (n = [], p = Ne(), p === e && (p = Eu()); p !== e; )
            n.push(p), p = Ne(), p === e && (p = Eu());
          n !== e ? (a.charCodeAt(r) === 93 ? (p = qu, r++) : (p = e, A === 0 && l(ju)), p !== e ? (a.charCodeAt(r) === 105 ? (E = Ou, r++) : (E = e, A === 0 && l(Tu)), E === e && (E = null), E !== e ? (R = u, i = Z0(t, n, E), u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e);
        } else
          r = u, u = e;
      else
        r = u, u = e;
      return A--, u === e && (i = e, A === 0 && l(z0)), u;
    }
    function Ne() {
      var u, i, t, n;
      return u = r, i = Eu(), i !== e ? (a.charCodeAt(r) === 45 ? (t = K0, r++) : (t = e, A === 0 && l(Q0)), t !== e ? (n = Eu(), n !== e ? (R = u, i = ur(i, n), u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function Eu() {
      var u, i, t;
      return u = r, i = r, A++, a.charCodeAt(r) === 93 ? (t = qu, r++) : (t = e, A === 0 && l(ju)), t === e && (a.charCodeAt(r) === 92 ? (t = V, r++) : (t = e, A === 0 && l(z)), t === e && (t = Y())), A--, t === e ? i = void 0 : (r = i, i = e), i !== e ? (t = U(), t !== e ? (R = u, i = nu(), u = i) : (r = u, u = e)) : (r = u, u = e), u === e && (u = r, a.charCodeAt(r) === 92 ? (i = V, r++) : (i = e, A === 0 && l(z)), i !== e ? (t = Ru(), t !== e ? (R = u, i = eu(t), u = i) : (r = u, u = e)) : (r = u, u = e), u === e && (u = mu())), u;
    }
    function mu() {
      var u, i, t;
      return u = r, a.charCodeAt(r) === 92 ? (i = V, r++) : (i = e, A === 0 && l(z)), i !== e ? (t = fu(), t !== e ? (R = u, i = er(), u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function Ru() {
      var u, i, t, n;
      return u = a1(), u === e && (u = r, a.charCodeAt(r) === 48 ? (i = rr, r++) : (i = e, A === 0 && l(sr)), i !== e ? (t = r, A++, n = Ge(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (R = u, i = ir(), u = i) : (r = u, u = e)) : (r = u, u = e), u === e && (u = c1(), u === e && (u = He()))), u;
    }
    function a1() {
      var u;
      return u = Ue(), u === e && (u = A1()), u;
    }
    function Ue() {
      var u, i;
      return a.charCodeAt(r) === 39 ? (u = iu, r++) : (u = e, A === 0 && l(tu)), u === e && (a.charCodeAt(r) === 34 ? (u = ru, r++) : (u = e, A === 0 && l(su)), u === e && (a.charCodeAt(r) === 92 ? (u = V, r++) : (u = e, A === 0 && l(z)), u === e && (u = r, a.charCodeAt(r) === 98 ? (i = tr, r++) : (i = e, A === 0 && l(nr)), i !== e && (R = u, i = ar()), u = i, u === e && (u = r, a.charCodeAt(r) === 102 ? (i = Ar, r++) : (i = e, A === 0 && l(or)), i !== e && (R = u, i = cr()), u = i, u === e && (u = r, a.charCodeAt(r) === 110 ? (i = pr, r++) : (i = e, A === 0 && l(lr)), i !== e && (R = u, i = fr()), u = i, u === e && (u = r, a.charCodeAt(r) === 114 ? (i = Er, r++) : (i = e, A === 0 && l(Cr)), i !== e && (R = u, i = Fr()), u = i, u === e && (u = r, a.charCodeAt(r) === 116 ? (i = Br, r++) : (i = e, A === 0 && l(Dr)), i !== e && (R = u, i = gr()), u = i, u === e && (u = r, a.charCodeAt(r) === 118 ? (i = dr, r++) : (i = e, A === 0 && l(hr)), i !== e && (R = u, i = $r()), u = i)))))))), u;
    }
    function A1() {
      var u, i, t;
      return u = r, i = r, A++, t = o1(), t === e && (t = Y()), A--, t === e ? i = void 0 : (r = i, i = e), i !== e ? (t = U(), t !== e ? (R = u, i = nu(), u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function o1() {
      var u;
      return u = Ue(), u === e && (u = Ge(), u === e && (a.charCodeAt(r) === 120 ? (u = wu, r++) : (u = e, A === 0 && l(Nu)), u === e && (a.charCodeAt(r) === 117 ? (u = Uu, r++) : (u = e, A === 0 && l(Hu))))), u;
    }
    function c1() {
      var u, i, t, n, p, E;
      return u = r, a.charCodeAt(r) === 120 ? (i = wu, r++) : (i = e, A === 0 && l(Nu)), i !== e ? (t = r, n = r, p = X(), p !== e ? (E = X(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e), n !== e ? t = a.substring(t, r) : t = n, t !== e ? (R = u, i = Gu(t), u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function He() {
      var u, i, t, n, p, E, y, q;
      return u = r, a.charCodeAt(r) === 117 ? (i = Uu, r++) : (i = e, A === 0 && l(Hu)), i !== e ? (t = r, n = r, p = X(), p !== e ? (E = X(), E !== e ? (y = X(), y !== e ? (q = X(), q !== e ? (p = [p, E, y, q], n = p) : (r = n, n = e)) : (r = n, n = e)) : (r = n, n = e)) : (r = n, n = e), n !== e ? t = a.substring(t, r) : t = n, t !== e ? (R = u, i = Gu(t), u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function Ge() {
      var u;
      return vr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(mr)), u;
    }
    function X() {
      var u;
      return Rr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(br)), u;
    }
    function p1() {
      var u, i;
      return u = r, a.charCodeAt(r) === 46 ? (i = xr, r++) : (i = e, A === 0 && l(Pr)), i !== e && (R = u, i = _r()), u = i, u;
    }
    function bu() {
      var u, i, t, n;
      return A++, u = r, a.charCodeAt(r) === 123 ? (i = Cu, r++) : (i = e, A === 0 && l(Fu)), i !== e ? (t = xu(), t !== e ? (a.charCodeAt(r) === 125 ? (n = Bu, r++) : (n = e, A === 0 && l(Du)), n !== e ? (R = u, i = kr(t), u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e), A--, u === e && (i = e, A === 0 && l(yr)), u;
    }
    function xu() {
      var u, i, t, n, p, E;
      if (u = r, i = [], t = [], n = r, p = r, A++, au.test(a.charAt(r)) ? (E = a.charAt(r), r++) : (E = e, A === 0 && l(Au)), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e), n !== e)
        for (; n !== e; )
          t.push(n), n = r, p = r, A++, au.test(a.charAt(r)) ? (E = a.charAt(r), r++) : (E = e, A === 0 && l(Au)), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e);
      else
        t = e;
      for (t === e && (t = r, a.charCodeAt(r) === 123 ? (n = Cu, r++) : (n = e, A === 0 && l(Fu)), n !== e ? (p = xu(), p !== e ? (a.charCodeAt(r) === 125 ? (E = Bu, r++) : (E = e, A === 0 && l(Du)), E !== e ? (n = [n, p, E], t = n) : (r = t, t = e)) : (r = t, t = e)) : (r = t, t = e)); t !== e; ) {
        if (i.push(t), t = [], n = r, p = r, A++, au.test(a.charAt(r)) ? (E = a.charAt(r), r++) : (E = e, A === 0 && l(Au)), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e), n !== e)
          for (; n !== e; )
            t.push(n), n = r, p = r, A++, au.test(a.charAt(r)) ? (E = a.charAt(r), r++) : (E = e, A === 0 && l(Au)), A--, E === e ? p = void 0 : (r = p, p = e), p !== e ? (E = U(), E !== e ? (p = [p, E], n = p) : (r = n, n = e)) : (r = n, n = e);
        else
          t = e;
        t === e && (t = r, a.charCodeAt(r) === 123 ? (n = Cu, r++) : (n = e, A === 0 && l(Fu)), n !== e ? (p = xu(), p !== e ? (a.charCodeAt(r) === 125 ? (E = Bu, r++) : (E = e, A === 0 && l(Du)), E !== e ? (n = [n, p, E], t = n) : (r = t, t = e)) : (r = t, t = e)) : (r = t, t = e));
      }
      return i !== e ? u = a.substring(u, r) : u = i, u;
    }
    function l1() {
      var u;
      return Sr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(Ir)), u;
    }
    function f1() {
      var u;
      return Or.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(Tr)), u;
    }
    function E1() {
      var u;
      return Lr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(qr)), u;
    }
    function C1() {
      var u;
      return jr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(wr)), u;
    }
    function F1() {
      var u;
      return Nr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(Ur)), u;
    }
    function B1() {
      var u;
      return Hr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(Gr)), u;
    }
    function D1() {
      var u;
      return Mr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(Vr)), u;
    }
    function g1() {
      var u;
      return zr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(Jr)), u;
    }
    function d1() {
      var u;
      return Yr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(Wr)), u;
    }
    function h1() {
      var u;
      return Xr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(Zr)), u;
    }
    function $1() {
      var u;
      return Kr.test(a.charAt(r)) ? (u = a.charAt(r), r++) : (u = e, A === 0 && l(Qr)), u;
    }
    function v1() {
      var u, i, t, n;
      return u = r, a.substr(r, 5) === Mu ? (i = Mu, r += 5) : (i = e, A === 0 && l(us)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function m1() {
      var u, i, t, n;
      return u = r, a.substr(r, 4) === Vu ? (i = Vu, r += 4) : (i = e, A === 0 && l(es)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function R1() {
      var u, i, t, n;
      return u = r, a.substr(r, 5) === zu ? (i = zu, r += 5) : (i = e, A === 0 && l(rs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function b1() {
      var u, i, t, n;
      return u = r, a.substr(r, 5) === Ju ? (i = Ju, r += 5) : (i = e, A === 0 && l(ss)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function x1() {
      var u, i, t, n;
      return u = r, a.substr(r, 5) === Yu ? (i = Yu, r += 5) : (i = e, A === 0 && l(is)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function P1() {
      var u, i, t, n;
      return u = r, a.substr(r, 8) === Wu ? (i = Wu, r += 8) : (i = e, A === 0 && l(ts)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function _1() {
      var u, i, t, n;
      return u = r, a.substr(r, 8) === Xu ? (i = Xu, r += 8) : (i = e, A === 0 && l(ns)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function y1() {
      var u, i, t, n;
      return u = r, a.substr(r, 7) === Zu ? (i = Zu, r += 7) : (i = e, A === 0 && l(as)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function k1() {
      var u, i, t, n;
      return u = r, a.substr(r, 6) === Ku ? (i = Ku, r += 6) : (i = e, A === 0 && l(As)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function S1() {
      var u, i, t, n;
      return u = r, a.substr(r, 2) === Qu ? (i = Qu, r += 2) : (i = e, A === 0 && l(os)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function I1() {
      var u, i, t, n;
      return u = r, a.substr(r, 4) === ue ? (i = ue, r += 4) : (i = e, A === 0 && l(cs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function O1() {
      var u, i, t, n;
      return u = r, a.substr(r, 4) === ee ? (i = ee, r += 4) : (i = e, A === 0 && l(ps)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function T1() {
      var u, i, t, n;
      return u = r, a.substr(r, 6) === re ? (i = re, r += 6) : (i = e, A === 0 && l(ls)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function L1() {
      var u, i, t, n;
      return u = r, a.substr(r, 7) === se ? (i = se, r += 7) : (i = e, A === 0 && l(fs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function q1() {
      var u, i, t, n;
      return u = r, a.substr(r, 5) === ie ? (i = ie, r += 5) : (i = e, A === 0 && l(Es)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function j1() {
      var u, i, t, n;
      return u = r, a.substr(r, 7) === te ? (i = te, r += 7) : (i = e, A === 0 && l(Cs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function w1() {
      var u, i, t, n;
      return u = r, a.substr(r, 3) === ne ? (i = ne, r += 3) : (i = e, A === 0 && l(Fs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function N1() {
      var u, i, t, n;
      return u = r, a.substr(r, 8) === ae ? (i = ae, r += 8) : (i = e, A === 0 && l(Bs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function U1() {
      var u, i, t, n;
      return u = r, a.substr(r, 2) === Ae ? (i = Ae, r += 2) : (i = e, A === 0 && l(Ds)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function H1() {
      var u, i, t, n;
      return u = r, a.substr(r, 6) === oe ? (i = oe, r += 6) : (i = e, A === 0 && l(gs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function G1() {
      var u, i, t, n;
      return u = r, a.substr(r, 10) === ce ? (i = ce, r += 10) : (i = e, A === 0 && l(ds)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function M1() {
      var u, i, t, n;
      return u = r, a.substr(r, 2) === pe ? (i = pe, r += 2) : (i = e, A === 0 && l(hs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function V1() {
      var u, i, t, n;
      return u = r, a.substr(r, 3) === le ? (i = le, r += 3) : (i = e, A === 0 && l($s)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function z1() {
      var u, i, t, n;
      return u = r, a.substr(r, 4) === fe ? (i = fe, r += 4) : (i = e, A === 0 && l(vs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function J1() {
      var u, i, t, n;
      return u = r, a.substr(r, 6) === Ee ? (i = Ee, r += 6) : (i = e, A === 0 && l(ms)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function Y1() {
      var u, i, t, n;
      return u = r, a.substr(r, 5) === Ce ? (i = Ce, r += 5) : (i = e, A === 0 && l(Rs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function W1() {
      var u, i, t, n;
      return u = r, a.substr(r, 6) === Fe ? (i = Fe, r += 6) : (i = e, A === 0 && l(bs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function X1() {
      var u, i, t, n;
      return u = r, a.substr(r, 4) === Be ? (i = Be, r += 4) : (i = e, A === 0 && l(xs)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function Z1() {
      var u, i, t, n;
      return u = r, a.substr(r, 5) === De ? (i = De, r += 5) : (i = e, A === 0 && l(Ps)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function K1() {
      var u, i, t, n;
      return u = r, a.substr(r, 4) === ge ? (i = ge, r += 4) : (i = e, A === 0 && l(_s)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function Q1() {
      var u, i, t, n;
      return u = r, a.substr(r, 3) === de ? (i = de, r += 3) : (i = e, A === 0 && l(ys)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function ui() {
      var u, i, t, n;
      return u = r, a.substr(r, 6) === he ? (i = he, r += 6) : (i = e, A === 0 && l(ks)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function ei() {
      var u, i, t, n;
      return u = r, a.substr(r, 3) === $e ? (i = $e, r += 3) : (i = e, A === 0 && l(Ss)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function ri() {
      var u, i, t, n;
      return u = r, a.substr(r, 4) === ve ? (i = ve, r += 4) : (i = e, A === 0 && l(Is)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function si() {
      var u, i, t, n;
      return u = r, a.substr(r, 5) === me ? (i = me, r += 5) : (i = e, A === 0 && l(Os)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function ii() {
      var u, i, t, n;
      return u = r, a.substr(r, 4) === Re ? (i = Re, r += 4) : (i = e, A === 0 && l(Ts)), i !== e ? (t = r, A++, n = x(), A--, n === e ? t = void 0 : (r = t, t = e), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u;
    }
    function O() {
      var u, i;
      for (u = [], i = lu(), i === e && (i = fu(), i === e && (i = Oe())); i !== e; )
        u.push(i), i = lu(), i === e && (i = fu(), i === e && (i = Oe()));
      return u;
    }
    function ti() {
      var u, i;
      for (u = [], i = lu(), i === e && (i = Te()); i !== e; )
        u.push(i), i = lu(), i === e && (i = Te());
      return u;
    }
    function Me() {
      var u, i, t, n;
      return u = r, i = O(), i !== e ? (a.charCodeAt(r) === 59 ? (t = Ls, r++) : (t = e, A === 0 && l(qs)), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e), u === e && (u = r, i = ti(), i !== e ? (t = Le(), t === e && (t = null), t !== e ? (n = fu(), n !== e ? (i = [i, t, n], u = i) : (r = u, u = e)) : (r = u, u = e)) : (r = u, u = e), u === e && (u = r, i = O(), i !== e ? (t = ni(), t !== e ? (i = [i, t], u = i) : (r = u, u = e)) : (r = u, u = e))), u;
    }
    function ni() {
      var u, i;
      return u = r, A++, a.length > r ? (i = a.charAt(r), r++) : (i = e, A === 0 && l(yu)), A--, i === e ? u = void 0 : (r = u, u = e), u;
    }
    var ai = {
      $: "text",
      "&": "simple_and",
      "!": "simple_not"
    }, Ai = {
      "?": "optional",
      "*": "zero_or_more",
      "+": "one_or_more"
    }, oi = {
      "&": "semantic_and",
      "!": "semantic_not"
    };
    function ci(u) {
      var i = [], t;
      for (t = 0; t < u.length; t++)
        u[t] !== "" && i.push(u[t]);
      return i;
    }
    function pi(u, i) {
      return u ? u[i] : null;
    }
    function Ve(u, i) {
      var t = new Array(u.length), n;
      for (n = 0; n < u.length; n++)
        t[n] = u[n][i];
      return t;
    }
    function ze(u, i, t) {
      return [u].concat(Ve(i, t));
    }
    if (cu = v(), cu !== e && r === a.length)
      return cu;
    throw cu !== e && r < a.length && l(Us()), Gs(
      gu,
      G < a.length ? a.charAt(G) : null,
      G < a.length ? pu(G, G + 1) : pu(G, G)
    );
  }
  return parser$1 = {
    SyntaxError: f,
    parse: F
  }, parser$1;
}
var visitor_1, hasRequiredVisitor;
function requireVisitor() {
  if (hasRequiredVisitor) return visitor_1;
  hasRequiredVisitor = 1;
  var C = requireObjects(), f = requireArrays(), F = {
    build: function(a) {
      function o($) {
        return a[$.type].apply(null, arguments);
      }
      function e() {
      }
      function B($) {
        var k = Array.prototype.slice.call(arguments, 1);
        o.apply(null, [$.expression].concat(k));
      }
      function v($) {
        return function(k) {
          var P = Array.prototype.slice.call(arguments, 1);
          f.each(k[$], function(m) {
            o.apply(null, [m].concat(P));
          });
        };
      }
      var h = {
        grammar: function($) {
          var k = Array.prototype.slice.call(arguments, 1);
          $.initializer && o.apply(null, [$.initializer].concat(k)), f.each($.rules, function(P) {
            o.apply(null, [P].concat(k));
          });
        },
        initializer: e,
        rule: B,
        named: B,
        choice: v("alternatives"),
        action: B,
        sequence: v("elements"),
        labeled: B,
        text: B,
        simple_and: B,
        simple_not: B,
        optional: B,
        zero_or_more: B,
        one_or_more: B,
        group: B,
        semantic_and: e,
        semantic_not: e,
        rule_ref: e,
        literal: e,
        class: e,
        any: e
      };
      return C.defaults(a, h), o;
    }
  };
  return visitor_1 = F, visitor_1;
}
var asts_1, hasRequiredAsts;
function requireAsts() {
  if (hasRequiredAsts) return asts_1;
  hasRequiredAsts = 1;
  var C = requireArrays(), f = requireVisitor(), F = {
    findRule: function(a, o) {
      return C.find(a.rules, function(e) {
        return e.name === o;
      });
    },
    indexOfRule: function(a, o) {
      return C.indexOf(a.rules, function(e) {
        return e.name === o;
      });
    },
    alwaysConsumesOnSuccess: function(a, o) {
      function e() {
        return !0;
      }
      function B() {
        return !1;
      }
      function v($) {
        return h($.expression);
      }
      var h = f.build({
        rule: v,
        named: v,
        choice: function($) {
          return C.every($.alternatives, h);
        },
        action: v,
        sequence: function($) {
          return C.some($.elements, h);
        },
        labeled: v,
        text: v,
        simple_and: B,
        simple_not: B,
        optional: B,
        zero_or_more: B,
        one_or_more: v,
        group: v,
        semantic_and: B,
        semantic_not: B,
        rule_ref: function($) {
          return h(F.findRule(a, $.name));
        },
        literal: function($) {
          return $.value !== "";
        },
        class: e,
        any: e
      });
      return h(o);
    }
  };
  return asts_1 = F, asts_1;
}
var reportUndefinedRules_1, hasRequiredReportUndefinedRules;
function requireReportUndefinedRules() {
  if (hasRequiredReportUndefinedRules) return reportUndefinedRules_1;
  hasRequiredReportUndefinedRules = 1;
  var C = requireGrammarError(), f = requireAsts(), F = requireVisitor();
  function a(o) {
    var e = F.build({
      rule_ref: function(B) {
        if (!f.findRule(o, B.name))
          throw new C(
            'Rule "' + B.name + '" is not defined.',
            B.location
          );
      }
    });
    e(o);
  }
  return reportUndefinedRules_1 = a, reportUndefinedRules_1;
}
var reportDuplicateRules_1, hasRequiredReportDuplicateRules;
function requireReportDuplicateRules() {
  if (hasRequiredReportDuplicateRules) return reportDuplicateRules_1;
  hasRequiredReportDuplicateRules = 1;
  var C = requireGrammarError(), f = requireVisitor();
  function F(a) {
    var o = {}, e = f.build({
      rule: function(B) {
        if (o.hasOwnProperty(B.name))
          throw new C(
            'Rule "' + B.name + '" is already defined at line ' + o[B.name].start.line + ", column " + o[B.name].start.column + ".",
            B.location
          );
        o[B.name] = B.location;
      }
    });
    e(a);
  }
  return reportDuplicateRules_1 = F, reportDuplicateRules_1;
}
var reportDuplicateLabels_1, hasRequiredReportDuplicateLabels;
function requireReportDuplicateLabels() {
  if (hasRequiredReportDuplicateLabels) return reportDuplicateLabels_1;
  hasRequiredReportDuplicateLabels = 1;
  var C = requireGrammarError(), f = requireArrays(), F = requireObjects(), a = requireVisitor();
  function o(e) {
    function B(h, $) {
      v(h.expression, F.clone($));
    }
    var v = a.build({
      rule: function(h) {
        v(h.expression, {});
      },
      choice: function(h, $) {
        f.each(h.alternatives, function(k) {
          v(k, F.clone($));
        });
      },
      action: B,
      labeled: function(h, $) {
        if ($.hasOwnProperty(h.label))
          throw new C(
            'Label "' + h.label + '" is already defined at line ' + $[h.label].start.line + ", column " + $[h.label].start.column + ".",
            h.location
          );
        v(h.expression, $), $[h.label] = h.location;
      },
      text: B,
      simple_and: B,
      simple_not: B,
      optional: B,
      zero_or_more: B,
      one_or_more: B,
      group: B
    });
    v(e);
  }
  return reportDuplicateLabels_1 = o, reportDuplicateLabels_1;
}
var reportInfiniteRecursion_1, hasRequiredReportInfiniteRecursion;
function requireReportInfiniteRecursion() {
  if (hasRequiredReportInfiniteRecursion) return reportInfiniteRecursion_1;
  hasRequiredReportInfiniteRecursion = 1;
  var C = requireArrays(), f = requireGrammarError(), F = requireAsts(), a = requireVisitor();
  function o(e) {
    var B = [], v = a.build({
      rule: function(h) {
        B.push(h.name), v(h.expression), B.pop(h.name);
      },
      sequence: function(h) {
        C.every(h.elements, function($) {
          return v($), !F.alwaysConsumesOnSuccess(e, $);
        });
      },
      rule_ref: function(h) {
        if (C.contains(B, h.name))
          throw B.push(h.name), new f(
            "Possible infinite loop when parsing (left recursion: " + B.join(" -> ") + ").",
            h.location
          );
        v(F.findRule(e, h.name));
      }
    });
    v(e);
  }
  return reportInfiniteRecursion_1 = o, reportInfiniteRecursion_1;
}
var reportInfiniteRepetition_1, hasRequiredReportInfiniteRepetition;
function requireReportInfiniteRepetition() {
  if (hasRequiredReportInfiniteRepetition) return reportInfiniteRepetition_1;
  hasRequiredReportInfiniteRepetition = 1;
  var C = requireGrammarError(), f = requireAsts(), F = requireVisitor();
  function a(o) {
    var e = F.build({
      zero_or_more: function(B) {
        if (!f.alwaysConsumesOnSuccess(o, B.expression))
          throw new C(
            "Possible infinite loop when parsing (repetition used with an expression that may not consume any input).",
            B.location
          );
      },
      one_or_more: function(B) {
        if (!f.alwaysConsumesOnSuccess(o, B.expression))
          throw new C(
            "Possible infinite loop when parsing (repetition used with an expression that may not consume any input).",
            B.location
          );
      }
    });
    e(o);
  }
  return reportInfiniteRepetition_1 = a, reportInfiniteRepetition_1;
}
var removeProxyRules_1, hasRequiredRemoveProxyRules;
function requireRemoveProxyRules() {
  if (hasRequiredRemoveProxyRules) return removeProxyRules_1;
  hasRequiredRemoveProxyRules = 1;
  var C = requireArrays(), f = requireVisitor();
  function F(a, o) {
    function e(h) {
      return h.type === "rule" && h.expression.type === "rule_ref";
    }
    function B(h, $, k) {
      var P = f.build({
        rule_ref: function(m) {
          m.name === $ && (m.name = k);
        }
      });
      P(h);
    }
    var v = [];
    C.each(a.rules, function(h, $) {
      e(h) && (B(a, h.name, h.expression.name), C.contains(o.allowedStartRules, h.name) || v.push($));
    }), v.reverse(), C.each(v, function(h) {
      a.rules.splice(h, 1);
    });
  }
  return removeProxyRules_1 = F, removeProxyRules_1;
}
var opcodes_1, hasRequiredOpcodes;
function requireOpcodes() {
  if (hasRequiredOpcodes) return opcodes_1;
  hasRequiredOpcodes = 1;
  var C = {
    /* Stack Manipulation */
    PUSH: 0,
    // PUSH c
    PUSH_UNDEFINED: 1,
    // PUSH_UNDEFINED
    PUSH_NULL: 2,
    // PUSH_NULL
    PUSH_FAILED: 3,
    // PUSH_FAILED
    PUSH_EMPTY_ARRAY: 4,
    // PUSH_EMPTY_ARRAY
    PUSH_CURR_POS: 5,
    // PUSH_CURR_POS
    POP: 6,
    // POP
    POP_CURR_POS: 7,
    // POP_CURR_POS
    POP_N: 8,
    // POP_N n
    NIP: 9,
    // NIP
    APPEND: 10,
    // APPEND
    WRAP: 11,
    // WRAP n
    TEXT: 12,
    // TEXT
    /* Conditions and Loops */
    IF: 13,
    // IF t, f
    IF_ERROR: 14,
    // IF_ERROR t, f
    IF_NOT_ERROR: 15,
    // IF_NOT_ERROR t, f
    WHILE_NOT_ERROR: 16,
    // WHILE_NOT_ERROR b
    /* Matching */
    MATCH_ANY: 17,
    // MATCH_ANY a, f, ...
    MATCH_STRING: 18,
    // MATCH_STRING s, a, f, ...
    MATCH_STRING_IC: 19,
    // MATCH_STRING_IC s, a, f, ...
    MATCH_REGEXP: 20,
    // MATCH_REGEXP r, a, f, ...
    ACCEPT_N: 21,
    // ACCEPT_N n
    ACCEPT_STRING: 22,
    // ACCEPT_STRING s
    FAIL: 23,
    // FAIL e
    /* Calls */
    LOAD_SAVED_POS: 24,
    // LOAD_SAVED_POS p
    UPDATE_SAVED_POS: 25,
    // UPDATE_SAVED_POS
    CALL: 26,
    // CALL f, n, pc, p1, p2, ..., pN
    /* Rules */
    RULE: 27,
    // RULE r
    /* Failure Reporting */
    SILENT_FAILS_ON: 28,
    // SILENT_FAILS_ON
    SILENT_FAILS_OFF: 29
    // SILENT_FAILS_OFF
  };
  return opcodes_1 = C, opcodes_1;
}
var js_1, hasRequiredJs;
function requireJs() {
  if (hasRequiredJs) return js_1;
  hasRequiredJs = 1;
  function C(F) {
    return F.charCodeAt(0).toString(16).toUpperCase();
  }
  var f = {
    stringEscape: function(F) {
      return F.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\x08/g, "\\b").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\f/g, "\\f").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(a) {
        return "\\x0" + C(a);
      }).replace(/[\x10-\x1F\x7F-\xFF]/g, function(a) {
        return "\\x" + C(a);
      }).replace(/[\u0100-\u0FFF]/g, function(a) {
        return "\\u0" + C(a);
      }).replace(/[\u1000-\uFFFF]/g, function(a) {
        return "\\u" + C(a);
      });
    },
    regexpClassEscape: function(F) {
      return F.replace(/\\/g, "\\\\").replace(/\//g, "\\/").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\v/g, "\\x0B").replace(/\f/g, "\\f").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(a) {
        return "\\x0" + C(a);
      }).replace(/[\x10-\x1F\x7F-\xFF]/g, function(a) {
        return "\\x" + C(a);
      }).replace(/[\u0100-\u0FFF]/g, function(a) {
        return "\\u0" + C(a);
      }).replace(/[\u1000-\uFFFF]/g, function(a) {
        return "\\u" + C(a);
      });
    }
  };
  return js_1 = f, js_1;
}
var generateBytecode_1, hasRequiredGenerateBytecode;
function requireGenerateBytecode() {
  if (hasRequiredGenerateBytecode) return generateBytecode_1;
  hasRequiredGenerateBytecode = 1;
  var C = requireArrays(), f = requireObjects(), F = requireAsts(), a = requireVisitor(), o = requireOpcodes(), e = requireJs();
  function B(v) {
    var h = [];
    function $(D) {
      var d = C.indexOf(h, D);
      return d === -1 ? h.push(D) - 1 : d;
    }
    function k(D, d) {
      return $(
        "function(" + D.join(", ") + ") {" + d + "}"
      );
    }
    function P() {
      return Array.prototype.concat.apply([], arguments);
    }
    function m(D, d, b) {
      return D.concat(
        [d.length, b.length],
        d,
        b
      );
    }
    function _(D, d) {
      return D.concat([d.length], d);
    }
    function S(D, d, b, T) {
      var I = C.map(f.values(b), function(L) {
        return T - L;
      });
      return [o.CALL, D, d, I.length].concat(I);
    }
    function M(D, d, b) {
      return P(
        [o.PUSH_CURR_POS],
        [o.SILENT_FAILS_ON],
        j(D, {
          sp: b.sp + 1,
          env: f.clone(b.env),
          action: null
        }),
        [o.SILENT_FAILS_OFF],
        m(
          [d ? o.IF_ERROR : o.IF_NOT_ERROR],
          P(
            [o.POP],
            [d ? o.POP : o.POP_CURR_POS],
            [o.PUSH_UNDEFINED]
          ),
          P(
            [o.POP],
            [d ? o.POP_CURR_POS : o.POP],
            [o.PUSH_FAILED]
          )
        )
      );
    }
    function K(D, d, b) {
      var T = k(f.keys(b.env), D);
      return P(
        [o.UPDATE_SAVED_POS],
        S(T, 0, b.env, b.sp),
        m(
          [o.IF],
          P(
            [o.POP],
            d ? [o.PUSH_FAILED] : [o.PUSH_UNDEFINED]
          ),
          P(
            [o.POP],
            d ? [o.PUSH_UNDEFINED] : [o.PUSH_FAILED]
          )
        )
      );
    }
    function Q(D) {
      return _(
        [o.WHILE_NOT_ERROR],
        P([o.APPEND], D)
      );
    }
    var j = a.build({
      grammar: function(D) {
        C.each(D.rules, j), D.consts = h;
      },
      rule: function(D) {
        D.bytecode = j(D.expression, {
          sp: -1,
          // stack pointer
          env: {},
          // mapping of label names to stack positions
          action: null
          // action nodes pass themselves to children here
        });
      },
      named: function(D, d) {
        var b = $(
          'peg$otherExpectation("' + e.stringEscape(D.name) + '")'
        );
        return P(
          [o.SILENT_FAILS_ON],
          j(D.expression, d),
          [o.SILENT_FAILS_OFF],
          m([o.IF_ERROR], [o.FAIL, b], [])
        );
      },
      choice: function(D, d) {
        function b(T, I) {
          return P(
            j(T[0], {
              sp: I.sp,
              env: f.clone(I.env),
              action: null
            }),
            T.length > 1 ? m(
              [o.IF_ERROR],
              P(
                [o.POP],
                b(T.slice(1), I)
              ),
              []
            ) : []
          );
        }
        return b(D.alternatives, d);
      },
      action: function(D, d) {
        var b = f.clone(d.env), T = D.expression.type !== "sequence" || D.expression.elements.length === 0, I = j(D.expression, {
          sp: d.sp + (T ? 1 : 0),
          env: b,
          action: D
        }), L = k(f.keys(b), D.code);
        return T ? P(
          [o.PUSH_CURR_POS],
          I,
          m(
            [o.IF_NOT_ERROR],
            P(
              [o.LOAD_SAVED_POS, 1],
              S(L, 1, b, d.sp + 2)
            ),
            []
          ),
          [o.NIP]
        ) : I;
      },
      sequence: function(D, d) {
        function b(T, I) {
          var L, Z;
          return T.length > 0 ? (L = D.elements.length - T.slice(1).length, P(
            j(T[0], {
              sp: I.sp,
              env: I.env,
              action: null
            }),
            m(
              [o.IF_NOT_ERROR],
              b(T.slice(1), {
                sp: I.sp + 1,
                env: I.env,
                action: I.action
              }),
              P(
                L > 1 ? [o.POP_N, L] : [o.POP],
                [o.POP_CURR_POS],
                [o.PUSH_FAILED]
              )
            )
          )) : I.action ? (Z = k(
            f.keys(I.env),
            I.action.code
          ), P(
            [o.LOAD_SAVED_POS, D.elements.length],
            S(
              Z,
              D.elements.length,
              I.env,
              I.sp
            ),
            [o.NIP]
          )) : P([o.WRAP, D.elements.length], [o.NIP]);
        }
        return P(
          [o.PUSH_CURR_POS],
          b(D.elements, {
            sp: d.sp + 1,
            env: d.env,
            action: d.action
          })
        );
      },
      labeled: function(D, d) {
        var b = f.clone(d.env);
        return d.env[D.label] = d.sp + 1, j(D.expression, {
          sp: d.sp,
          env: b,
          action: null
        });
      },
      text: function(D, d) {
        return P(
          [o.PUSH_CURR_POS],
          j(D.expression, {
            sp: d.sp + 1,
            env: f.clone(d.env),
            action: null
          }),
          m(
            [o.IF_NOT_ERROR],
            P([o.POP], [o.TEXT]),
            [o.NIP]
          )
        );
      },
      simple_and: function(D, d) {
        return M(D.expression, !1, d);
      },
      simple_not: function(D, d) {
        return M(D.expression, !0, d);
      },
      optional: function(D, d) {
        return P(
          j(D.expression, {
            sp: d.sp,
            env: f.clone(d.env),
            action: null
          }),
          m(
            [o.IF_ERROR],
            P([o.POP], [o.PUSH_NULL]),
            []
          )
        );
      },
      zero_or_more: function(D, d) {
        var b = j(D.expression, {
          sp: d.sp + 1,
          env: f.clone(d.env),
          action: null
        });
        return P(
          [o.PUSH_EMPTY_ARRAY],
          b,
          Q(b),
          [o.POP]
        );
      },
      one_or_more: function(D, d) {
        var b = j(D.expression, {
          sp: d.sp + 1,
          env: f.clone(d.env),
          action: null
        });
        return P(
          [o.PUSH_EMPTY_ARRAY],
          b,
          m(
            [o.IF_NOT_ERROR],
            P(Q(b), [o.POP]),
            P([o.POP], [o.POP], [o.PUSH_FAILED])
          )
        );
      },
      group: function(D, d) {
        return j(D.expression, {
          sp: d.sp,
          env: f.clone(d.env),
          action: null
        });
      },
      semantic_and: function(D, d) {
        return K(D.code, !1, d);
      },
      semantic_not: function(D, d) {
        return K(D.code, !0, d);
      },
      rule_ref: function(D) {
        return [o.RULE, F.indexOfRule(v, D.name)];
      },
      literal: function(D) {
        var d, b;
        return D.value.length > 0 ? (d = $(
          '"' + e.stringEscape(
            D.ignoreCase ? D.value.toLowerCase() : D.value
          ) + '"'
        ), b = $(
          'peg$literalExpectation("' + e.stringEscape(D.value) + '", ' + D.ignoreCase + ")"
        ), m(
          D.ignoreCase ? [o.MATCH_STRING_IC, d] : [o.MATCH_STRING, d],
          D.ignoreCase ? [o.ACCEPT_N, D.value.length] : [o.ACCEPT_STRING, d],
          [o.FAIL, b]
        )) : (d = $('""'), [o.PUSH, d]);
      },
      class: function(D) {
        var d, b, T, I;
        return D.parts.length > 0 ? d = "/^[" + (D.inverted ? "^" : "") + C.map(D.parts, function(L) {
          return L instanceof Array ? e.regexpClassEscape(L[0]) + "-" + e.regexpClassEscape(L[1]) : e.regexpClassEscape(L);
        }).join("") + "]/" + (D.ignoreCase ? "i" : "") : d = D.inverted ? "/^[\\S\\s]/" : "/^(?!)/", b = "[" + C.map(D.parts, function(L) {
          return L instanceof Array ? '["' + e.stringEscape(L[0]) + '", "' + e.stringEscape(L[1]) + '"]' : '"' + e.stringEscape(L) + '"';
        }).join(", ") + "]", T = $(d), I = $(
          "peg$classExpectation(" + b + ", " + D.inverted + ", " + D.ignoreCase + ")"
        ), m(
          [o.MATCH_REGEXP, T],
          [o.ACCEPT_N, 1],
          [o.FAIL, I]
        );
      },
      any: function() {
        var D = $("peg$anyExpectation()");
        return m(
          [o.MATCH_ANY],
          [o.ACCEPT_N, 1],
          [o.FAIL, D]
        );
      }
    });
    j(v);
  }
  return generateBytecode_1 = B, generateBytecode_1;
}
var generateJs, hasRequiredGenerateJs;
function requireGenerateJs() {
  if (hasRequiredGenerateJs) return generateJs;
  hasRequiredGenerateJs = 1;
  var arrays = requireArrays(), objects = requireObjects(), asts = requireAsts(), op = requireOpcodes(), js = requireJs();
  function generateJS(ast, options) {
    function indent2(C) {
      return C.replace(/^(.+)$/gm, "  $1");
    }
    function indent6(C) {
      return C.replace(/^(.+)$/gm, "      $1");
    }
    function indent10(C) {
      return C.replace(/^(.+)$/gm, "          $1");
    }
    function generateTables() {
      return options.optimize === "size" ? [
        "peg$consts = [",
        indent2(ast.consts.join(`,
`)),
        "],",
        "",
        "peg$bytecode = [",
        indent2(arrays.map(ast.rules, function(C) {
          return 'peg$decode("' + js.stringEscape(arrays.map(
            C.bytecode,
            function(f) {
              return String.fromCharCode(f + 32);
            }
          ).join("")) + '")';
        }).join(`,
`)),
        "],"
      ].join(`
`) : arrays.map(
        ast.consts,
        function(C, f) {
          return "peg$c" + f + " = " + C + ",";
        }
      ).join(`
`);
    }
    function generateRuleHeader(C, f) {
      var F = [];
      return F.push(""), options.trace && F.push([
        "peg$tracer.trace({",
        '  type:     "rule.enter",',
        "  rule:     " + C + ",",
        "  location: peg$computeLocation(startPos, startPos)",
        "});",
        ""
      ].join(`
`)), options.cache && (F.push([
        "var key    = peg$currPos * " + ast.rules.length + " + " + f + ",",
        "    cached = peg$resultsCache[key];",
        "",
        "if (cached) {",
        "  peg$currPos = cached.nextPos;",
        ""
      ].join(`
`)), options.trace && F.push([
        "if (cached.result !== peg$FAILED) {",
        "  peg$tracer.trace({",
        '    type:   "rule.match",',
        "    rule:   " + C + ",",
        "    result: cached.result,",
        "    location: peg$computeLocation(startPos, peg$currPos)",
        "  });",
        "} else {",
        "  peg$tracer.trace({",
        '    type: "rule.fail",',
        "    rule: " + C + ",",
        "    location: peg$computeLocation(startPos, startPos)",
        "  });",
        "}",
        ""
      ].join(`
`)), F.push([
        "  return cached.result;",
        "}",
        ""
      ].join(`
`))), F.join(`
`);
    }
    function generateRuleFooter(C, f) {
      var F = [];
      return options.cache && F.push([
        "",
        "peg$resultsCache[key] = { nextPos: peg$currPos, result: " + f + " };"
      ].join(`
`)), options.trace && F.push([
        "",
        "if (" + f + " !== peg$FAILED) {",
        "  peg$tracer.trace({",
        '    type:   "rule.match",',
        "    rule:   " + C + ",",
        "    result: " + f + ",",
        "    location: peg$computeLocation(startPos, peg$currPos)",
        "  });",
        "} else {",
        "  peg$tracer.trace({",
        '    type: "rule.fail",',
        "    rule: " + C + ",",
        "    location: peg$computeLocation(startPos, startPos)",
        "  });",
        "}"
      ].join(`
`)), F.push([
        "",
        "return " + f + ";"
      ].join(`
`)), F.join(`
`);
    }
    function generateInterpreter() {
      var C = [];
      function f(o, e) {
        var B = e + 3, v = "bc[ip + " + (B - 2) + "]", h = "bc[ip + " + (B - 1) + "]";
        return [
          "ends.push(end);",
          "ips.push(ip + " + B + " + " + v + " + " + h + ");",
          "",
          "if (" + o + ") {",
          "  end = ip + " + B + " + " + v + ";",
          "  ip += " + B + ";",
          "} else {",
          "  end = ip + " + B + " + " + v + " + " + h + ";",
          "  ip += " + B + " + " + v + ";",
          "}",
          "",
          "break;"
        ].join(`
`);
      }
      function F(o) {
        var e = 2, B = "bc[ip + " + (e - 1) + "]";
        return [
          "if (" + o + ") {",
          "  ends.push(end);",
          "  ips.push(ip);",
          "",
          "  end = ip + " + e + " + " + B + ";",
          "  ip += " + e + ";",
          "} else {",
          "  ip += " + e + " + " + B + ";",
          "}",
          "",
          "break;"
        ].join(`
`);
      }
      function a() {
        var o = 4, e = "bc[ip + " + (o - 1) + "]";
        return [
          "params = bc.slice(ip + " + o + ", ip + " + o + " + " + e + ");",
          "for (i = 0; i < " + e + "; i++) {",
          "  params[i] = stack[stack.length - 1 - params[i]];",
          "}",
          "",
          "stack.splice(",
          "  stack.length - bc[ip + 2],",
          "  bc[ip + 2],",
          "  peg$consts[bc[ip + 1]].apply(null, params)",
          ");",
          "",
          "ip += " + o + " + " + e + ";",
          "break;"
        ].join(`
`);
      }
      return C.push([
        "function peg$decode(s) {",
        "  var bc = new Array(s.length), i;",
        "",
        "  for (i = 0; i < s.length; i++) {",
        "    bc[i] = s.charCodeAt(i) - 32;",
        "  }",
        "",
        "  return bc;",
        "}",
        "",
        "function peg$parseRule(index) {"
      ].join(`
`)), options.trace ? C.push([
        "  var bc       = peg$bytecode[index],",
        "      ip       = 0,",
        "      ips      = [],",
        "      end      = bc.length,",
        "      ends     = [],",
        "      stack    = [],",
        "      startPos = peg$currPos,",
        "      params, i;"
      ].join(`
`)) : C.push([
        "  var bc    = peg$bytecode[index],",
        "      ip    = 0,",
        "      ips   = [],",
        "      end   = bc.length,",
        "      ends  = [],",
        "      stack = [],",
        "      params, i;"
      ].join(`
`)), C.push(indent2(generateRuleHeader("peg$ruleNames[index]", "index"))), C.push([
        /*
         * The point of the outer loop and the |ips| & |ends| stacks is to avoid
         * recursive calls for interpreting parts of bytecode. In other words, we
         * implement the |interpret| operation of the abstract machine without
         * function calls. Such calls would likely slow the parser down and more
         * importantly cause stack overflows for complex grammars.
         */
        "  while (true) {",
        "    while (ip < end) {",
        "      switch (bc[ip]) {",
        "        case " + op.PUSH + ":",
        // PUSH c
        "          stack.push(peg$consts[bc[ip + 1]]);",
        "          ip += 2;",
        "          break;",
        "",
        "        case " + op.PUSH_UNDEFINED + ":",
        // PUSH_UNDEFINED
        "          stack.push(void 0);",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.PUSH_NULL + ":",
        // PUSH_NULL
        "          stack.push(null);",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.PUSH_FAILED + ":",
        // PUSH_FAILED
        "          stack.push(peg$FAILED);",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.PUSH_EMPTY_ARRAY + ":",
        // PUSH_EMPTY_ARRAY
        "          stack.push([]);",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.PUSH_CURR_POS + ":",
        // PUSH_CURR_POS
        "          stack.push(peg$currPos);",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.POP + ":",
        // POP
        "          stack.pop();",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.POP_CURR_POS + ":",
        // POP_CURR_POS
        "          peg$currPos = stack.pop();",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.POP_N + ":",
        // POP_N n
        "          stack.length -= bc[ip + 1];",
        "          ip += 2;",
        "          break;",
        "",
        "        case " + op.NIP + ":",
        // NIP
        "          stack.splice(-2, 1);",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.APPEND + ":",
        // APPEND
        "          stack[stack.length - 2].push(stack.pop());",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.WRAP + ":",
        // WRAP n
        "          stack.push(stack.splice(stack.length - bc[ip + 1], bc[ip + 1]));",
        "          ip += 2;",
        "          break;",
        "",
        "        case " + op.TEXT + ":",
        // TEXT
        "          stack.push(input.substring(stack.pop(), peg$currPos));",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.IF + ":",
        // IF t, f
        indent10(f("stack[stack.length - 1]", 0)),
        "",
        "        case " + op.IF_ERROR + ":",
        // IF_ERROR t, f
        indent10(f(
          "stack[stack.length - 1] === peg$FAILED",
          0
        )),
        "",
        "        case " + op.IF_NOT_ERROR + ":",
        // IF_NOT_ERROR t, f
        indent10(
          f(
            "stack[stack.length - 1] !== peg$FAILED",
            0
          )
        ),
        "",
        "        case " + op.WHILE_NOT_ERROR + ":",
        // WHILE_NOT_ERROR b
        indent10(F("stack[stack.length - 1] !== peg$FAILED")),
        "",
        "        case " + op.MATCH_ANY + ":",
        // MATCH_ANY a, f, ...
        indent10(f("input.length > peg$currPos", 0)),
        "",
        "        case " + op.MATCH_STRING + ":",
        // MATCH_STRING s, a, f, ...
        indent10(f(
          "input.substr(peg$currPos, peg$consts[bc[ip + 1]].length) === peg$consts[bc[ip + 1]]",
          1
        )),
        "",
        "        case " + op.MATCH_STRING_IC + ":",
        // MATCH_STRING_IC s, a, f, ...
        indent10(f(
          "input.substr(peg$currPos, peg$consts[bc[ip + 1]].length).toLowerCase() === peg$consts[bc[ip + 1]]",
          1
        )),
        "",
        "        case " + op.MATCH_REGEXP + ":",
        // MATCH_REGEXP r, a, f, ...
        indent10(f(
          "peg$consts[bc[ip + 1]].test(input.charAt(peg$currPos))",
          1
        )),
        "",
        "        case " + op.ACCEPT_N + ":",
        // ACCEPT_N n
        "          stack.push(input.substr(peg$currPos, bc[ip + 1]));",
        "          peg$currPos += bc[ip + 1];",
        "          ip += 2;",
        "          break;",
        "",
        "        case " + op.ACCEPT_STRING + ":",
        // ACCEPT_STRING s
        "          stack.push(peg$consts[bc[ip + 1]]);",
        "          peg$currPos += peg$consts[bc[ip + 1]].length;",
        "          ip += 2;",
        "          break;",
        "",
        "        case " + op.FAIL + ":",
        // FAIL e
        "          stack.push(peg$FAILED);",
        "          if (peg$silentFails === 0) {",
        "            peg$fail(peg$consts[bc[ip + 1]]);",
        "          }",
        "          ip += 2;",
        "          break;",
        "",
        "        case " + op.LOAD_SAVED_POS + ":",
        // LOAD_SAVED_POS p
        "          peg$savedPos = stack[stack.length - 1 - bc[ip + 1]];",
        "          ip += 2;",
        "          break;",
        "",
        "        case " + op.UPDATE_SAVED_POS + ":",
        // UPDATE_SAVED_POS
        "          peg$savedPos = peg$currPos;",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.CALL + ":",
        // CALL f, n, pc, p1, p2, ..., pN
        indent10(a()),
        "",
        "        case " + op.RULE + ":",
        // RULE r
        "          stack.push(peg$parseRule(bc[ip + 1]));",
        "          ip += 2;",
        "          break;",
        "",
        "        case " + op.SILENT_FAILS_ON + ":",
        // SILENT_FAILS_ON
        "          peg$silentFails++;",
        "          ip++;",
        "          break;",
        "",
        "        case " + op.SILENT_FAILS_OFF + ":",
        // SILENT_FAILS_OFF
        "          peg$silentFails--;",
        "          ip++;",
        "          break;",
        "",
        "        default:",
        '          throw new Error("Invalid opcode: " + bc[ip] + ".");',
        "      }",
        "    }",
        "",
        "    if (ends.length > 0) {",
        "      end = ends.pop();",
        "      ip = ips.pop();",
        "    } else {",
        "      break;",
        "    }",
        "  }"
      ].join(`
`)), C.push(indent2(generateRuleFooter("peg$ruleNames[index]", "stack[0]"))), C.push("}"), C.join(`
`);
    }
    function generateRuleFunction(rule) {
      var parts = [], code;
      function c(C) {
        return "peg$c" + C;
      }
      function s(C) {
        return "s" + C;
      }
      var stack = {
        sp: -1,
        maxSp: -1,
        push: function(C) {
          var f = s(++this.sp) + " = " + C + ";";
          return this.sp > this.maxSp && (this.maxSp = this.sp), f;
        },
        pop: function(C) {
          var f;
          return C === void 0 ? s(this.sp--) : (f = arrays.map(arrays.range(this.sp - C + 1, this.sp + 1), s), this.sp -= C, f);
        },
        top: function() {
          return s(this.sp);
        },
        index: function(C) {
          return s(this.sp - C);
        }
      };
      function compile(bc) {
        var ip = 0, end = bc.length, parts = [], value;
        function compileCondition(C, f) {
          var F = f + 3, a = bc[ip + F - 2], o = bc[ip + F - 1], e = stack.sp, B, v, h, $;
          if (ip += F, B = compile(bc.slice(ip, ip + a)), h = stack.sp, ip += a, o > 0 && (stack.sp = e, v = compile(bc.slice(ip, ip + o)), $ = stack.sp, ip += o, h !== $))
            throw new Error(
              "Branches of a condition must move the stack pointer in the same way."
            );
          parts.push("if (" + C + ") {"), parts.push(indent2(B)), o > 0 && (parts.push("} else {"), parts.push(indent2(v))), parts.push("}");
        }
        function compileLoop(C) {
          var f = 2, F = bc[ip + f - 1], a = stack.sp, o, e;
          if (ip += f, o = compile(bc.slice(ip, ip + F)), e = stack.sp, ip += F, e !== a)
            throw new Error("Body of a loop can't move the stack pointer.");
          parts.push("while (" + C + ") {"), parts.push(indent2(o)), parts.push("}");
        }
        function compileCall() {
          var C = 4, f = bc[ip + C - 1], F = c(bc[ip + 1]) + "(" + arrays.map(
            bc.slice(ip + C, ip + C + f),
            function(a) {
              return stack.index(a);
            }
          ).join(", ") + ")";
          stack.pop(bc[ip + 2]), parts.push(stack.push(F)), ip += C + f;
        }
        for (; ip < end; )
          switch (bc[ip]) {
            case op.PUSH:
              parts.push(stack.push(c(bc[ip + 1]))), ip += 2;
              break;
            case op.PUSH_CURR_POS:
              parts.push(stack.push("peg$currPos")), ip++;
              break;
            case op.PUSH_UNDEFINED:
              parts.push(stack.push("void 0")), ip++;
              break;
            case op.PUSH_NULL:
              parts.push(stack.push("null")), ip++;
              break;
            case op.PUSH_FAILED:
              parts.push(stack.push("peg$FAILED")), ip++;
              break;
            case op.PUSH_EMPTY_ARRAY:
              parts.push(stack.push("[]")), ip++;
              break;
            case op.POP:
              stack.pop(), ip++;
              break;
            case op.POP_CURR_POS:
              parts.push("peg$currPos = " + stack.pop() + ";"), ip++;
              break;
            case op.POP_N:
              stack.pop(bc[ip + 1]), ip += 2;
              break;
            case op.NIP:
              value = stack.pop(), stack.pop(), parts.push(stack.push(value)), ip++;
              break;
            case op.APPEND:
              value = stack.pop(), parts.push(stack.top() + ".push(" + value + ");"), ip++;
              break;
            case op.WRAP:
              parts.push(
                stack.push("[" + stack.pop(bc[ip + 1]).join(", ") + "]")
              ), ip += 2;
              break;
            case op.TEXT:
              parts.push(
                stack.push("input.substring(" + stack.pop() + ", peg$currPos)")
              ), ip++;
              break;
            case op.IF:
              compileCondition(stack.top(), 0);
              break;
            case op.IF_ERROR:
              compileCondition(stack.top() + " === peg$FAILED", 0);
              break;
            case op.IF_NOT_ERROR:
              compileCondition(stack.top() + " !== peg$FAILED", 0);
              break;
            case op.WHILE_NOT_ERROR:
              compileLoop(stack.top() + " !== peg$FAILED");
              break;
            case op.MATCH_ANY:
              compileCondition("input.length > peg$currPos", 0);
              break;
            case op.MATCH_STRING:
              compileCondition(
                eval(ast.consts[bc[ip + 1]]).length > 1 ? "input.substr(peg$currPos, " + eval(ast.consts[bc[ip + 1]]).length + ") === " + c(bc[ip + 1]) : "input.charCodeAt(peg$currPos) === " + eval(ast.consts[bc[ip + 1]]).charCodeAt(0),
                1
              );
              break;
            case op.MATCH_STRING_IC:
              compileCondition(
                "input.substr(peg$currPos, " + eval(ast.consts[bc[ip + 1]]).length + ").toLowerCase() === " + c(bc[ip + 1]),
                1
              );
              break;
            case op.MATCH_REGEXP:
              compileCondition(
                c(bc[ip + 1]) + ".test(input.charAt(peg$currPos))",
                1
              );
              break;
            case op.ACCEPT_N:
              parts.push(stack.push(
                bc[ip + 1] > 1 ? "input.substr(peg$currPos, " + bc[ip + 1] + ")" : "input.charAt(peg$currPos)"
              )), parts.push(
                bc[ip + 1] > 1 ? "peg$currPos += " + bc[ip + 1] + ";" : "peg$currPos++;"
              ), ip += 2;
              break;
            case op.ACCEPT_STRING:
              parts.push(stack.push(c(bc[ip + 1]))), parts.push(
                eval(ast.consts[bc[ip + 1]]).length > 1 ? "peg$currPos += " + eval(ast.consts[bc[ip + 1]]).length + ";" : "peg$currPos++;"
              ), ip += 2;
              break;
            case op.FAIL:
              parts.push(stack.push("peg$FAILED")), parts.push("if (peg$silentFails === 0) { peg$fail(" + c(bc[ip + 1]) + "); }"), ip += 2;
              break;
            case op.LOAD_SAVED_POS:
              parts.push("peg$savedPos = " + stack.index(bc[ip + 1]) + ";"), ip += 2;
              break;
            case op.UPDATE_SAVED_POS:
              parts.push("peg$savedPos = peg$currPos;"), ip++;
              break;
            case op.CALL:
              compileCall();
              break;
            case op.RULE:
              parts.push(stack.push("peg$parse" + ast.rules[bc[ip + 1]].name + "()")), ip += 2;
              break;
            case op.SILENT_FAILS_ON:
              parts.push("peg$silentFails++;"), ip++;
              break;
            case op.SILENT_FAILS_OFF:
              parts.push("peg$silentFails--;"), ip++;
              break;
            default:
              throw new Error("Invalid opcode: " + bc[ip] + ".");
          }
        return parts.join(`
`);
      }
      return code = compile(rule.bytecode), parts.push("function peg$parse" + rule.name + "() {"), options.trace ? parts.push([
        "  var " + arrays.map(arrays.range(0, stack.maxSp + 1), s).join(", ") + ",",
        "      startPos = peg$currPos;"
      ].join(`
`)) : parts.push(
        "  var " + arrays.map(arrays.range(0, stack.maxSp + 1), s).join(", ") + ";"
      ), parts.push(indent2(generateRuleHeader(
        '"' + js.stringEscape(rule.name) + '"',
        asts.indexOfRule(ast, rule.name)
      ))), parts.push(indent2(code)), parts.push(indent2(generateRuleFooter(
        '"' + js.stringEscape(rule.name) + '"',
        s(0)
      ))), parts.push("}"), parts.join(`
`);
    }
    function generateToplevel() {
      var C = [], f, F, a, o, e;
      return C.push([
        "function peg$subclass(child, parent) {",
        "  function ctor() { this.constructor = child; }",
        "  ctor.prototype = parent.prototype;",
        "  child.prototype = new ctor();",
        "}",
        "",
        "function peg$SyntaxError(message, expected, found, location) {",
        "  this.message  = message;",
        "  this.expected = expected;",
        "  this.found    = found;",
        "  this.location = location;",
        '  this.name     = "SyntaxError";',
        "",
        '  if (typeof Error.captureStackTrace === "function") {',
        "    Error.captureStackTrace(this, peg$SyntaxError);",
        "  }",
        "}",
        "",
        "peg$subclass(peg$SyntaxError, Error);",
        "",
        "peg$SyntaxError.buildMessage = function(expected, found) {",
        "  var DESCRIBE_EXPECTATION_FNS = {",
        "        literal: function(expectation) {",
        '          return "\\"" + literalEscape(expectation.text) + "\\"";',
        "        },",
        "",
        '        "class": function(expectation) {',
        '          var escapedParts = "",',
        "              i;",
        "",
        "          for (i = 0; i < expectation.parts.length; i++) {",
        "            escapedParts += expectation.parts[i] instanceof Array",
        '              ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1])',
        "              : classEscape(expectation.parts[i]);",
        "          }",
        "",
        '          return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";',
        "        },",
        "",
        "        any: function(expectation) {",
        '          return "any character";',
        "        },",
        "",
        "        end: function(expectation) {",
        '          return "end of input";',
        "        },",
        "",
        "        other: function(expectation) {",
        "          return expectation.description;",
        "        }",
        "      };",
        "",
        "  function hex(ch) {",
        "    return ch.charCodeAt(0).toString(16).toUpperCase();",
        "  }",
        "",
        "  function literalEscape(s) {",
        "    return s",
        "      .replace(/\\\\/g, '\\\\\\\\')",
        // backslash
        `      .replace(/"/g,  '\\\\"')`,
        // closing double quote
        "      .replace(/\\0/g, '\\\\0')",
        // null
        "      .replace(/\\t/g, '\\\\t')",
        // horizontal tab
        "      .replace(/\\n/g, '\\\\n')",
        // line feed
        "      .replace(/\\r/g, '\\\\r')",
        // carriage return
        "      .replace(/[\\x00-\\x0F]/g,          function(ch) { return '\\\\x0' + hex(ch); })",
        "      .replace(/[\\x10-\\x1F\\x7F-\\x9F]/g, function(ch) { return '\\\\x'  + hex(ch); });",
        "  }",
        "",
        "  function classEscape(s) {",
        "    return s",
        "      .replace(/\\\\/g, '\\\\\\\\')",
        // backslash
        "      .replace(/\\]/g, '\\\\]')",
        // closing bracket
        "      .replace(/\\^/g, '\\\\^')",
        // caret
        "      .replace(/-/g,  '\\\\-')",
        // dash
        "      .replace(/\\0/g, '\\\\0')",
        // null
        "      .replace(/\\t/g, '\\\\t')",
        // horizontal tab
        "      .replace(/\\n/g, '\\\\n')",
        // line feed
        "      .replace(/\\r/g, '\\\\r')",
        // carriage return
        "      .replace(/[\\x00-\\x0F]/g,          function(ch) { return '\\\\x0' + hex(ch); })",
        "      .replace(/[\\x10-\\x1F\\x7F-\\x9F]/g, function(ch) { return '\\\\x'  + hex(ch); });",
        "  }",
        "",
        "  function describeExpectation(expectation) {",
        "    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);",
        "  }",
        "",
        "  function describeExpected(expected) {",
        "    var descriptions = new Array(expected.length),",
        "        i, j;",
        "",
        "    for (i = 0; i < expected.length; i++) {",
        "      descriptions[i] = describeExpectation(expected[i]);",
        "    }",
        "",
        "    descriptions.sort();",
        "",
        "    if (descriptions.length > 0) {",
        "      for (i = 1, j = 1; i < descriptions.length; i++) {",
        "        if (descriptions[i - 1] !== descriptions[i]) {",
        "          descriptions[j] = descriptions[i];",
        "          j++;",
        "        }",
        "      }",
        "      descriptions.length = j;",
        "    }",
        "",
        "    switch (descriptions.length) {",
        "      case 1:",
        "        return descriptions[0];",
        "",
        "      case 2:",
        '        return descriptions[0] + " or " + descriptions[1];',
        "",
        "      default:",
        '        return descriptions.slice(0, -1).join(", ")',
        '          + ", or "',
        "          + descriptions[descriptions.length - 1];",
        "    }",
        "  }",
        "",
        "  function describeFound(found) {",
        '    return found ? "\\"" + literalEscape(found) + "\\"" : "end of input";',
        "  }",
        "",
        '  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";',
        "};",
        ""
      ].join(`
`)), options.trace && C.push([
        "function peg$DefaultTracer() {",
        "  this.indentLevel = 0;",
        "}",
        "",
        "peg$DefaultTracer.prototype.trace = function(event) {",
        "  var that = this;",
        "",
        "  function log(event) {",
        "    function repeat(string, n) {",
        '       var result = "", i;',
        "",
        "       for (i = 0; i < n; i++) {",
        "         result += string;",
        "       }",
        "",
        "       return result;",
        "    }",
        "",
        "    function pad(string, length) {",
        '      return string + repeat(" ", length - string.length);',
        "    }",
        "",
        '    if (typeof console === "object") {',
        // IE 8-10
        "      console.log(",
        '        event.location.start.line + ":" + event.location.start.column + "-"',
        '          + event.location.end.line + ":" + event.location.end.column + " "',
        '          + pad(event.type, 10) + " "',
        '          + repeat("  ", that.indentLevel) + event.rule',
        "      );",
        "    }",
        "  }",
        "",
        "  switch (event.type) {",
        '    case "rule.enter":',
        "      log(event);",
        "      this.indentLevel++;",
        "      break;",
        "",
        '    case "rule.match":',
        "      this.indentLevel--;",
        "      log(event);",
        "      break;",
        "",
        '    case "rule.fail":',
        "      this.indentLevel--;",
        "      log(event);",
        "      break;",
        "",
        "    default:",
        '      throw new Error("Invalid event type: " + event.type + ".");',
        "  }",
        "};",
        ""
      ].join(`
`)), C.push([
        "function peg$parse(input, options) {",
        "  options = options !== void 0 ? options : {};",
        "",
        "  var peg$FAILED = {},",
        ""
      ].join(`
`)), options.optimize === "size" ? (f = "{ " + arrays.map(
        options.allowedStartRules,
        function(B) {
          return B + ": " + asts.indexOfRule(ast, B);
        }
      ).join(", ") + " }", F = asts.indexOfRule(ast, options.allowedStartRules[0]), C.push([
        "      peg$startRuleIndices = " + f + ",",
        "      peg$startRuleIndex   = " + F + ","
      ].join(`
`))) : (a = "{ " + arrays.map(
        options.allowedStartRules,
        function(B) {
          return B + ": peg$parse" + B;
        }
      ).join(", ") + " }", o = "peg$parse" + options.allowedStartRules[0], C.push([
        "      peg$startRuleFunctions = " + a + ",",
        "      peg$startRuleFunction  = " + o + ","
      ].join(`
`))), C.push(""), C.push(indent6(generateTables())), C.push([
        "",
        "      peg$currPos          = 0,",
        "      peg$savedPos         = 0,",
        "      peg$posDetailsCache  = [{ line: 1, column: 1 }],",
        "      peg$maxFailPos       = 0,",
        "      peg$maxFailExpected  = [],",
        "      peg$silentFails      = 0,",
        // 0 = report failures, > 0 = silence failures
        ""
      ].join(`
`)), options.cache && C.push([
        "      peg$resultsCache = {},",
        ""
      ].join(`
`)), options.trace && (options.optimize === "size" && (e = "[" + arrays.map(
        ast.rules,
        function(B) {
          return '"' + js.stringEscape(B.name) + '"';
        }
      ).join(", ") + "]", C.push([
        "      peg$ruleNames = " + e + ",",
        ""
      ].join(`
`))), C.push([
        '      peg$tracer = "tracer" in options ? options.tracer : new peg$DefaultTracer(),',
        ""
      ].join(`
`))), C.push([
        "      peg$result;",
        ""
      ].join(`
`)), options.optimize === "size" ? C.push([
        '  if ("startRule" in options) {',
        "    if (!(options.startRule in peg$startRuleIndices)) {",
        `      throw new Error("Can't start parsing from rule \\"" + options.startRule + "\\".");`,
        "    }",
        "",
        "    peg$startRuleIndex = peg$startRuleIndices[options.startRule];",
        "  }"
      ].join(`
`)) : C.push([
        '  if ("startRule" in options) {',
        "    if (!(options.startRule in peg$startRuleFunctions)) {",
        `      throw new Error("Can't start parsing from rule \\"" + options.startRule + "\\".");`,
        "    }",
        "",
        "    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];",
        "  }"
      ].join(`
`)), C.push([
        "",
        "  function text() {",
        "    return input.substring(peg$savedPos, peg$currPos);",
        "  }",
        "",
        "  function location() {",
        "    return peg$computeLocation(peg$savedPos, peg$currPos);",
        "  }",
        "",
        "  function expected(description, location) {",
        "    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)",
        "",
        "    throw peg$buildStructuredError(",
        "      [peg$otherExpectation(description)],",
        "      input.substring(peg$savedPos, peg$currPos),",
        "      location",
        "    );",
        "  }",
        "",
        "  function error(message, location) {",
        "    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)",
        "",
        "    throw peg$buildSimpleError(message, location);",
        "  }",
        "",
        "  function peg$literalExpectation(text, ignoreCase) {",
        '    return { type: "literal", text: text, ignoreCase: ignoreCase };',
        "  }",
        "",
        "  function peg$classExpectation(parts, inverted, ignoreCase) {",
        '    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };',
        "  }",
        "",
        "  function peg$anyExpectation() {",
        '    return { type: "any" };',
        "  }",
        "",
        "  function peg$endExpectation() {",
        '    return { type: "end" };',
        "  }",
        "",
        "  function peg$otherExpectation(description) {",
        '    return { type: "other", description: description };',
        "  }",
        "",
        "  function peg$computePosDetails(pos) {",
        "    var details = peg$posDetailsCache[pos], p;",
        "",
        "    if (details) {",
        "      return details;",
        "    } else {",
        "      p = pos - 1;",
        "      while (!peg$posDetailsCache[p]) {",
        "        p--;",
        "      }",
        "",
        "      details = peg$posDetailsCache[p];",
        "      details = {",
        "        line:   details.line,",
        "        column: details.column",
        "      };",
        "",
        "      while (p < pos) {",
        "        if (input.charCodeAt(p) === 10) {",
        "          details.line++;",
        "          details.column = 1;",
        "        } else {",
        "          details.column++;",
        "        }",
        "",
        "        p++;",
        "      }",
        "",
        "      peg$posDetailsCache[pos] = details;",
        "      return details;",
        "    }",
        "  }",
        "",
        "  function peg$computeLocation(startPos, endPos) {",
        "    var startPosDetails = peg$computePosDetails(startPos),",
        "        endPosDetails   = peg$computePosDetails(endPos);",
        "",
        "    return {",
        "      start: {",
        "        offset: startPos,",
        "        line:   startPosDetails.line,",
        "        column: startPosDetails.column",
        "      },",
        "      end: {",
        "        offset: endPos,",
        "        line:   endPosDetails.line,",
        "        column: endPosDetails.column",
        "      }",
        "    };",
        "  }",
        "",
        "  function peg$fail(expected) {",
        "    if (peg$currPos < peg$maxFailPos) { return; }",
        "",
        "    if (peg$currPos > peg$maxFailPos) {",
        "      peg$maxFailPos = peg$currPos;",
        "      peg$maxFailExpected = [];",
        "    }",
        "",
        "    peg$maxFailExpected.push(expected);",
        "  }",
        "",
        "  function peg$buildSimpleError(message, location) {",
        "    return new peg$SyntaxError(message, null, null, location);",
        "  }",
        "",
        "  function peg$buildStructuredError(expected, found, location) {",
        "    return new peg$SyntaxError(",
        "      peg$SyntaxError.buildMessage(expected, found),",
        "      expected,",
        "      found,",
        "      location",
        "    );",
        "  }",
        ""
      ].join(`
`)), options.optimize === "size" ? (C.push(indent2(generateInterpreter())), C.push("")) : arrays.each(ast.rules, function(B) {
        C.push(indent2(generateRuleFunction(B))), C.push("");
      }), ast.initializer && (C.push(indent2(ast.initializer.code)), C.push("")), options.optimize === "size" ? C.push("  peg$result = peg$parseRule(peg$startRuleIndex);") : C.push("  peg$result = peg$startRuleFunction();"), C.push([
        "",
        "  if (peg$result !== peg$FAILED && peg$currPos === input.length) {",
        "    return peg$result;",
        "  } else {",
        "    if (peg$result !== peg$FAILED && peg$currPos < input.length) {",
        "      peg$fail(peg$endExpectation());",
        "    }",
        "",
        "    throw peg$buildStructuredError(",
        "      peg$maxFailExpected,",
        "      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,",
        "      peg$maxFailPos < input.length",
        "        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)",
        "        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)",
        "    );",
        "  }",
        "}"
      ].join(`
`)), C.join(`
`);
    }
    function generateWrapper(C) {
      function f() {
        return [
          "/*",
          " * Generated by PEG.js 0.10.0.",
          " *",
          " * http://pegjs.org/",
          " */"
        ].join(`
`);
      }
      function F() {
        return options.trace ? [
          "{",
          "  SyntaxError:   peg$SyntaxError,",
          "  DefaultTracer: peg$DefaultTracer,",
          "  parse:         peg$parse",
          "}"
        ].join(`
`) : [
          "{",
          "  SyntaxError: peg$SyntaxError,",
          "  parse:       peg$parse",
          "}"
        ].join(`
`);
      }
      var a = {
        bare: function() {
          return [
            f(),
            "(function() {",
            '  "use strict";',
            "",
            indent2(C),
            "",
            indent2("return " + F() + ";"),
            "})()"
          ].join(`
`);
        },
        commonjs: function() {
          var o = [], e = objects.keys(options.dependencies), B = arrays.map(
            e,
            function(v) {
              return v + ' = require("' + js.stringEscape(options.dependencies[v]) + '")';
            }
          );
          return o.push([
            f(),
            "",
            '"use strict";',
            ""
          ].join(`
`)), B.length > 0 && (o.push("var " + B.join(", ") + ";"), o.push("")), o.push([
            C,
            "",
            "module.exports = " + F() + ";",
            ""
          ].join(`
`)), o.join(`
`);
        },
        amd: function() {
          var o = objects.values(options.dependencies), e = objects.keys(options.dependencies), B = "[" + arrays.map(
            o,
            function(h) {
              return '"' + js.stringEscape(h) + '"';
            }
          ).join(", ") + "]", v = e.join(", ");
          return [
            f(),
            "define(" + B + ", function(" + v + ") {",
            '  "use strict";',
            "",
            indent2(C),
            "",
            indent2("return " + F() + ";"),
            "});",
            ""
          ].join(`
`);
        },
        globals: function() {
          return [
            f(),
            "(function(root) {",
            '  "use strict";',
            "",
            indent2(C),
            "",
            indent2("root." + options.exportVar + " = " + F() + ";"),
            "})(this);",
            ""
          ].join(`
`);
        },
        umd: function() {
          var o = [], e = objects.values(options.dependencies), B = objects.keys(options.dependencies), v = "[" + arrays.map(
            e,
            function(k) {
              return '"' + js.stringEscape(k) + '"';
            }
          ).join(", ") + "]", h = arrays.map(
            e,
            function(k) {
              return 'require("' + js.stringEscape(k) + '")';
            }
          ).join(", "), $ = B.join(", ");
          return o.push([
            f(),
            "(function(root, factory) {",
            '  if (typeof define === "function" && define.amd) {',
            "    define(" + v + ", factory);",
            '  } else if (typeof module === "object" && module.exports) {',
            "    module.exports = factory(" + h + ");"
          ].join(`
`)), options.exportVar !== null && o.push([
            "  } else {",
            "    root." + options.exportVar + " = factory();"
          ].join(`
`)), o.push([
            "  }",
            "})(this, function(" + $ + ") {",
            '  "use strict";',
            "",
            indent2(C),
            "",
            indent2("return " + F() + ";"),
            "});",
            ""
          ].join(`
`)), o.join(`
`);
        }
      };
      return a[options.format]();
    }
    ast.code = generateWrapper(generateToplevel());
  }
  return generateJs = generateJS, generateJs;
}
var compiler_1, hasRequiredCompiler;
function requireCompiler() {
  if (hasRequiredCompiler) return compiler_1;
  hasRequiredCompiler = 1;
  var arrays = requireArrays(), objects = requireObjects(), compiler = {
    /*
     * AST node visitor builder. Useful mainly for plugins which manipulate the
     * AST.
     */
    visitor: requireVisitor(),
    /*
     * Compiler passes.
     *
     * Each pass is a function that is passed the AST. It can perform checks on it
     * or modify it as needed. If the pass encounters a semantic error, it throws
     * |peg.GrammarError|.
     */
    passes: {
      check: {
        reportUndefinedRules: requireReportUndefinedRules(),
        reportDuplicateRules: requireReportDuplicateRules(),
        reportDuplicateLabels: requireReportDuplicateLabels(),
        reportInfiniteRecursion: requireReportInfiniteRecursion(),
        reportInfiniteRepetition: requireReportInfiniteRepetition()
      },
      transform: {
        removeProxyRules: requireRemoveProxyRules()
      },
      generate: {
        generateBytecode: requireGenerateBytecode(),
        generateJS: requireGenerateJs()
      }
    },
    /*
     * Generates a parser from a specified grammar AST. Throws |peg.GrammarError|
     * if the AST contains a semantic error. Note that not all errors are detected
     * during the generation and some may protrude to the generated parser and
     * cause its malfunction.
     */
    compile: function(ast, passes, options) {
      options = options !== void 0 ? options : {};
      var stage;
      options = objects.clone(options), objects.defaults(options, {
        allowedStartRules: [ast.rules[0].name],
        cache: !1,
        dependencies: {},
        exportVar: null,
        format: "bare",
        optimize: "speed",
        output: "parser",
        trace: !1
      });
      for (stage in passes)
        passes.hasOwnProperty(stage) && arrays.each(passes[stage], function(C) {
          C(ast, options);
        });
      switch (options.output) {
        case "parser":
          return eval(ast.code);
        case "source":
          return ast.code;
      }
    }
  };
  return compiler_1 = compiler, compiler_1;
}
var peg_1, hasRequiredPeg;
function requirePeg() {
  if (hasRequiredPeg) return peg_1;
  hasRequiredPeg = 1;
  var C = requireArrays(), f = requireObjects(), F = {
    /* PEG.js version (uses semantic versioning). */
    VERSION: "0.10.0",
    GrammarError: requireGrammarError(),
    parser: requireParser(),
    compiler: requireCompiler(),
    /*
     * Generates a parser from a specified grammar and returns it.
     *
     * The grammar must be a string in the format described by the metagramar in
     * the parser.pegjs file.
     *
     * Throws |peg.parser.SyntaxError| if the grammar contains a syntax error or
     * |peg.GrammarError| if it contains a semantic error. Note that not all
     * errors are detected during the generation and some may protrude to the
     * generated parser and cause its malfunction.
     */
    generate: function(a, o) {
      o = o !== void 0 ? o : {};
      function e(h) {
        var $ = {}, k;
        for (k in h)
          h.hasOwnProperty(k) && ($[k] = f.values(h[k]));
        return $;
      }
      o = f.clone(o);
      var B = "plugins" in o ? o.plugins : [], v = {
        parser: F.parser,
        passes: e(F.compiler.passes)
      };
      return C.each(B, function(h) {
        h.use(v, o);
      }), F.compiler.compile(
        v.parser.parse(a),
        v.passes,
        o
      );
    }
  };
  return peg_1 = F, peg_1;
}
var pegExports = requirePeg();
const pegjs = /* @__PURE__ */ getDefaultExportFromCjs(pegExports), parser = pegjs.generate(`
  Expr
  = OrExpr

  Object "object"
  = [0-9]+ {
    return '%' + text() + '%';
  }

  _ "whitespace"
  = [ \\t\\n\\r]*

  NotExpr
  = "(" _ expr:Expr _ ")" { return expr; }
  / Object
  / "not" _ expr:NotExpr {
    return { not: expr }
  }

  AndExpr
  = head:NotExpr tail:(_ "and" _ NotExpr)+ {
    const els = tail.map(els => els[3]);
    return { and: [head, ...els] }
  }
  / head:NotExpr tail:(_ NotExpr)+ {
    const els = tail.map(els => els[1]);
    return { and: [head, ...els] }
  }
  / NotExpr

  OrExpr
  = head:AndExpr tail:(_ "or" _ AndExpr)+ {
    const els = tail.map(els => els[3]);
    return { or: [head, ...els] }
  }
  / AndExpr
`);
function parseAndMap(C, f) {
  const F = parser.parse(C), a = Object.entries(f).reduce((o, [e, B]) => o.replace(new RegExp(`"%${e}%"`, "g"), JSON.stringify(B)), JSON.stringify(F));
  return JSON.parse(a);
}
function testExpression(C) {
  try {
    return parser.parse(C), !0;
  } catch {
    return !1;
  }
}
class BooleanParser {
  static parseAndMap(f, F) {
    return parseAndMap(f, F);
  }
  static test(f) {
    return testExpression(f);
  }
}
export {
  BooleanParser
};
//# sourceMappingURL=metadata-utils2.js.map
